/**
 * Prisma Zod Generator - Single File (inlined)
 * Auto-generated. Do not edit.
 */
import { z } from 'zod';
// File: TransactionIsolationLevel.schema.ts
export const TransactionIsolationLevelSchema = z.enum(['ReadUncommitted', 'ReadCommitted', 'RepeatableRead', 'Serializable']);
// File: GlobalSettingScalarFieldEnum.schema.ts
export const GlobalSettingScalarFieldEnumSchema = z.enum(['key', 'value']);
// File: ResourceScalarFieldEnum.schema.ts
export const ResourceScalarFieldEnumSchema = z.enum(['id', 'name', 'createdAt', 'updatedAt']);
// File: RoleScalarFieldEnum.schema.ts
export const RoleScalarFieldEnumSchema = z.enum(['id', 'name', 'type', 'createdAt', 'updatedAt']);
// File: RoleResourcePermissionScalarFieldEnum.schema.ts
export const RoleResourcePermissionScalarFieldEnumSchema = z.enum(['id', 'roleId', 'resourceId', 'permission', 'createdAt', 'updatedAt']);
// File: InstituteUserRoleScalarFieldEnum.schema.ts
export const InstituteUserRoleScalarFieldEnumSchema = z.enum(['id', 'instituteUserId', 'roleId', 'createdAt', 'updatedAt']);
// File: CourseUserRoleScalarFieldEnum.schema.ts
export const CourseUserRoleScalarFieldEnumSchema = z.enum(['id', 'courseUserId', 'roleId', 'createdAt', 'updatedAt']);
// File: LmsCourseScalarFieldEnum.schema.ts
export const LmsCourseScalarFieldEnumSchema = z.enum(['id', 'instituteId', 'courseId', 'courseInfo', 'accessControlUuid', 'createdAt', 'updatedAt', 'verityEnabled', 'subAccountId']);
// File: LmsCourseUserScalarFieldEnum.schema.ts
export const LmsCourseUserScalarFieldEnumSchema = z.enum(['id', 'userId', 'courseId', 'viewVideos', 'createdAt', 'updatedAt']);
// File: LmsQuizScalarFieldEnum.schema.ts
export const LmsQuizScalarFieldEnumSchema = z.enum(['id', 'courseId', 'quizId', 'quizInfo', 'other', 'isDeleted', 'summary', 'createdAt', 'updatedAt', 'sourcesLastScanned', 'ltiPayload']);
// File: VerityAssessmentScalarFieldEnum.schema.ts
export const VerityAssessmentScalarFieldEnumSchema = z.enum(['quizId', 'type', 'isPublished', 'syncGradebook', 'startTime', 'endTime', 'allowLateSubmission', 'lateSubmissionDate', 'shuffleQuestions', 'questionsPerPage', 'numAttempts', 'showScoreOnSubmit', 'duration', 'description', 'moduleId', 'scoringStrategy', 'createdAt', 'updatedAt']);
// File: AssessmentQuestionScalarFieldEnum.schema.ts
export const AssessmentQuestionScalarFieldEnumSchema = z.enum(['id', 'assessmentId', 'lmsProvidedQuestionId', 'title', 'bodyHtml', 'bodyText', 'sources', 'numSources', 'decoySiteHostname', 'decoySitePostId', 'isDeleted', 'createdAt', 'updatedAt']);
// File: QuestionSourcesScalarFieldEnum.schema.ts
export const QuestionSourcesScalarFieldEnumSchema = z.enum(['id', 'hostname', 'email', 'createdAt', 'updatedAt']);
// File: LmsQuizCacheScalarFieldEnum.schema.ts
export const LmsQuizCacheScalarFieldEnumSchema = z.enum(['id', 'quizId', 'courseId', 'platformId', 'activityUrl', 'createdAt', 'updatedAt']);
// File: LmsQuizCopyCheckedScalarFieldEnum.schema.ts
export const LmsQuizCopyCheckedScalarFieldEnumSchema = z.enum(['id', 'instituteId', 'lmsCourseId', 'quizId', 'createdAt']);
// File: Lti1p3InstituteScalarFieldEnum.schema.ts
export const Lti1p3InstituteScalarFieldEnumSchema = z.enum(['id', 'instituteName', 'lms', 'language', 'origin', 'issId', 'ltiClientId', 'lmsApiClientId', 'lmsApiClientSecret', 'lmsApiIncludeD2LCorePermission', 'deploymentId', 'accessControlUuid', 'isDisabled', 'createdAt', 'updatedAt', 'institutionType', 'accountType']);
// File: InstitutePendingDeletionScalarFieldEnum.schema.ts
export const InstitutePendingDeletionScalarFieldEnumSchema = z.enum(['id', 'instituteId', 'initiatingUserId', 'initiatingUserName', 'initiatingUserEmail', 'deletionDate', 'status', 'createdAt', 'updatedAt']);
// File: LuminaPartnerKeyScalarFieldEnum.schema.ts
export const LuminaPartnerKeyScalarFieldEnumSchema = z.enum(['id', 'keyId', 'keyHash', 'label', 'createdAt', 'lastUsedAt', 'revokedAt']);
// File: LuminaResultsTokenScalarFieldEnum.schema.ts
export const LuminaResultsTokenScalarFieldEnumSchema = z.enum(['id', 'tokenId', 'instituteId', 'courseId', 'lmsQuizId', 'studentId', 'createdAt', 'expiresAt', 'redeemedAt']);
// File: LtiDeploymentHostnameScalarFieldEnum.schema.ts
export const LtiDeploymentHostnameScalarFieldEnumSchema = z.enum(['id', 'ltiDeploymentId', 'hostname', 'createdAt', 'updatedAt']);
// File: Lti1p3IssScalarFieldEnum.schema.ts
export const Lti1p3IssScalarFieldEnumSchema = z.enum(['id', 'iss', 'platformOidcEndpoint', 'platformJwksEndpoint', 'createdAt', 'updatedAt']);
// File: ProctoringExemptionScalarFieldEnum.schema.ts
export const ProctoringExemptionScalarFieldEnumSchema = z.enum(['id', 'assessmentId', 'userId', 'proctoringOptionProfileId', 'accommodationNotes', 'createdAt', 'updatedAt']);
// File: InstitutionProctoringAccommodationScalarFieldEnum.schema.ts
export const InstitutionProctoringAccommodationScalarFieldEnumSchema = z.enum(['id', 'userId', 'proctoringOptionProfileId', 'accommodationNotes', 'createdAt', 'updatedAt']);
// File: LmsTokenScalarFieldEnum.schema.ts
export const LmsTokenScalarFieldEnumSchema = z.enum(['id', 'instituteUserId', 'accessToken', 'refreshToken', 'exp', 'createdAt', 'updatedAt', 'isDeleted']);
// File: ProctoringOptionScalarFieldEnum.schema.ts
export const ProctoringOptionScalarFieldEnumSchema = z.enum(['id', 'videoRecordingMode', 'secondaryVideoRecordingMode', 'audioRecordingMode', 'recordScreen', 'scanRoom', 'recordWebTraffic', 'detectSidePanel', 'oneScreenEnforcementMode', 'disableNewTab', 'closeOpenTabs', 'tabWhiteList', 'disableClipboardMode', 'enableGuidedAccessMode', 'restrictHandoffMode', 'showRecordingPanel', 'idVerification', 'idVerificationEnableAi', 'faceTrackingMode', 'objectDetectionMode', 'enforceLockdown', 'enforceMobile', 'isExtension', 'isLockdown', 'isMobile', 'isChromeOs', 'isBrowser', 'recordClipboard', 'recordInput', 'excludedWebTrafficRecordingUrls', 'disableSpellcheck', 'disablePrinting', 'disableRightClick', 'extensionBlockMode', 'allowedExtensionsList', 'logInstalledExtensions', 'tabBlockList', 'hideOtherWindows', 'keyboardShortcutBlockList', 'disableDownloadFiles', 'applicationBlockMode', 'blockWindowedApplications', 'applicationBlockList', 'allowedApplicationsList', 'blockVirtualMachines', 'recordApplicationsActivity', 'logRunningApplications', 'quietEnvironment', 'enableCalculator', 'enableWhiteboard', 'enableCodeEditor', 'codeEditorRoomId', 'uploadScratchNotes', 'idVerificationMode', 'restrictDevices', 'enableManualEndProctoring', 'enableReferenceMaterial', 'referenceMaterialMode', 'audioTranscription', 'flaggedKeywords', 'uploadSignature', 'enableGeofence', 'geofenceLocations', 'disableVirtualCamera', 'enableIpAddressRestriction', 'allowedIpAddresses', 'createdAt', 'updatedAt']);
// File: ThirdPartyAssessmentOptionScalarFieldEnum.schema.ts
export const ThirdPartyAssessmentOptionScalarFieldEnumSchema = z.enum(['id', 'thirdPartyUrl', 'password', 'proctoringAssessmentConfigurationId', 'thirdPartyPlatformId', 'createdAt', 'updatedAt']);
// File: ProctoringAssessmentConfigurationScalarFieldEnum.schema.ts
export const ProctoringAssessmentConfigurationScalarFieldEnumSchema = z.enum(['id', 'lmsQuizId', 'proctoringOptionProfileId', 'enabled', 'isLiveProctored', 'isLivePopIn', 'enablePostReview', 'forceChromeOsManagedGuestSession', 'password', 'createdAt', 'updatedAt']);
// File: ProctoringOptionProfileScalarFieldEnum.schema.ts
export const ProctoringOptionProfileScalarFieldEnumSchema = z.enum(['id', 'name', 'proctoringOptionId', 'type', 'createdAt', 'updatedAt']);
// File: ProctoringOptionInstituteProfileScalarFieldEnum.schema.ts
export const ProctoringOptionInstituteProfileScalarFieldEnumSchema = z.enum(['id', 'enforced', 'instituteId', 'proctoringOptionProfileId']);
// File: ProctoringOptionCourseProfileScalarFieldEnum.schema.ts
export const ProctoringOptionCourseProfileScalarFieldEnumSchema = z.enum(['id', 'courseId', 'proctoringOptionProfileId']);
// File: ProctoringOptionUserProfileScalarFieldEnum.schema.ts
export const ProctoringOptionUserProfileScalarFieldEnumSchema = z.enum(['id', 'userId', 'proctoringOptionProfileId']);
// File: ProctoringOptionSubAccountProfileScalarFieldEnum.schema.ts
export const ProctoringOptionSubAccountProfileScalarFieldEnumSchema = z.enum(['id', 'proctoringOptionProfileId', 'subAccountId']);
// File: VerityInstituteSettingsScalarFieldEnum.schema.ts
export const VerityInstituteSettingsScalarFieldEnumSchema = z.enum(['id', 'instituteId', 'allowLiveProctoring', 'liveProctoringResetableCredits', 'liveProctoringCreditsResetDate', 'liveProctoringOneTimeCredits', 'allowLivePopIn', 'livePopInResetableCredits', 'livePopInCreditsResetDate', 'livePopInOneTimeCredits', 'allowLivePopInPostReview', 'allowAutomatedProctoring', 'allowStandaloneMode', 'disableProctorMode', 'allowDemoMode', 'allowAiStrictMode', 'allowExtensionPlatform', 'allowLockdownPlatform', 'allowMobilePlatform', 'allowBrowserPlatform', 'showAllAssessments', 'liteMode', 'liteModeViewReports', 'salesforceId', 'cleanupEnabled', 'cutoffDate', 'cleanupFrequency', 'lastCleanupAt', 'allowVerityAssessment', 'tier', 'disabledProctoringOptions', 'createdAt', 'updatedAt']);
// File: InstituteUsageLimitScalarFieldEnum.schema.ts
export const InstituteUsageLimitScalarFieldEnumSchema = z.enum(['id', 'instituteId', 'usageMode', 'category', 'proctorGroupId', 'type', 'resetableLimit', 'resetDate', 'oneTimeCredits', 'annualType', 'oneTimeCreditsType']);
// File: InstituteUsageCacheScalarFieldEnum.schema.ts
export const InstituteUsageCacheScalarFieldEnumSchema = z.enum(['id', 'instituteId', 'category', 'proctorGroupId', 'type', 'date', 'usage']);
// File: InstituteUsageUserCacheScalarFieldEnum.schema.ts
export const InstituteUsageUserCacheScalarFieldEnumSchema = z.enum(['id', 'instituteId', 'category', 'proctorGroupId', 'date', 'studentId']);
// File: LiveSessionUsageCacheScalarFieldEnum.schema.ts
export const LiveSessionUsageCacheScalarFieldEnumSchema = z.enum(['id', 'instituteId', 'proctorGroupIds', 'startTime', 'endTime', 'hours', 'sessions', 'user']);
// File: ProctoringSessionScalarFieldEnum.schema.ts
export const ProctoringSessionScalarFieldEnumSchema = z.enum(['id', 'uuid', 'createdAt', 'updatedAt', 'lmsQuizId', 'studentId', 'screencaptureAvailability', 'webcamAvailability', 'screencaptureVideos', 'webcamVideos', 'idPhotoAvailable', 'personPhotoAvailable', 'liveSessionId', 'liveUserSessionId', 'postReviewPending', 'liveProctorSummaryPending', 'usageTracked', 'ipAddress', 'isWebcamAndScreenCaptureDeleted', 'webcamAndScreenCaptureDeleteCause', 'webcamAndScreenCaptureDeleteAt', 'isRoomScanDeleted', 'roomScanDeleteCause', 'roomScanDeleteAt', 'syncedToLmsAt', 'signatureType']);
// File: DemoSessionScalarFieldEnum.schema.ts
export const DemoSessionScalarFieldEnumSchema = z.enum(['id', 'email', 'firstName', 'lastName', 'organization', 'role', 'verificationTokenHash', 'verificationExpiresAt', 'verifiedAt', 'demoSessionTokenHash', 'demoUserId', 'accessControlAccountId', 'principalExpiresAt', 'proctoringSessionUuid', 'completedAt', 'resultStatus', 'processingStartedAt', 'processingDeadlineAt', 'resultReadyAt', 'resultTokenHash', 'resultEmailTokenCiphertext', 'resultExpiresAt', 'resultEmailStatus', 'resultEmailAttempts', 'resultEmailLastAttemptAt', 'resultEmailNextAttemptAt', 'resultEmailSentAt', 'cameraDisconnectSelfReportedAt', 'createdAt', 'updatedAt']);
// File: ProctoringSessionAnomaliesScalarFieldEnum.schema.ts
export const ProctoringSessionAnomaliesScalarFieldEnumSchema = z.enum(['id', 'proctoringSessionId', 'type', 'flagLevel', 'timeStart', 'timeEnd', 'resolved', 'comment', 'createdAt', 'updatedAt']);
// File: ProctoringSessionEventScalarFieldEnum.schema.ts
export const ProctoringSessionEventScalarFieldEnumSchema = z.enum(['id', 'proctoringSessionId', 'type', 'name', 'details', 'time', 'endTime', 'createdAt', 'updatedAt', 'anomalyRef']);
// File: ProctoringSessionRekognitionEventScalarFieldEnum.schema.ts
export const ProctoringSessionRekognitionEventScalarFieldEnumSchema = z.enum(['id', 'proctoringSessionId', 'time', 'storage']);
// File: UserScalarFieldEnum.schema.ts
export const UserScalarFieldEnumSchema = z.enum(['id', 'lmsProvidedUserId', 'instituteId', 'editInstitute', 'name', 'userInfo', 'other', 'accessControlUuid', 'stripeUserId', 'createdAt', 'updatedAt']);
// File: UserSessionScalarFieldEnum.schema.ts
export const UserSessionScalarFieldEnumSchema = z.enum(['id', 'sid', 'expires', 'data', 'createdAt', 'updatedAt', 'userId']);
// File: UserSecurityPinScalarFieldEnum.schema.ts
export const UserSecurityPinScalarFieldEnumSchema = z.enum(['userId', 'pin', 'createdAt', 'updatedAt']);
// File: UserStateScalarFieldEnum.schema.ts
export const UserStateScalarFieldEnumSchema = z.enum(['userId', 'npsSurveyShownAt', 'latestReportShownAt', 'candidateWelcomeShownAt', 'loginCount', 'activeSetupStep', 'tosAgreedAt', 'createdAt', 'updatedAt']);
// File: YujaAccountScalarFieldEnum.schema.ts
export const YujaAccountScalarFieldEnumSchema = z.enum(['id', 'username', 'password', 'roleId', 'createdAt', 'updatedAt']);
// File: YujaAccountRoleScalarFieldEnum.schema.ts
export const YujaAccountRoleScalarFieldEnumSchema = z.enum(['id', 'role', 'permissions', 'createdAt', 'updatedAt']);
// File: YujaDebugInstanceScalarFieldEnum.schema.ts
export const YujaDebugInstanceScalarFieldEnumSchema = z.enum(['id', 'uuid', 'system', 'createdAt', 'updatedAt']);
// File: YujaDebugStatisticScalarFieldEnum.schema.ts
export const YujaDebugStatisticScalarFieldEnumSchema = z.enum(['id', 'instanceId', 'userId', 'userSessionId', 'proctoringSessionId', 'type', 'time', 'details', 'createdAt', 'updatedAt']);
// File: InstallationScalarFieldEnum.schema.ts
export const InstallationScalarFieldEnumSchema = z.enum(['id', 'platform', 'version', 'fingerprint', 'details', 'createdAt', 'updatedAt']);
// File: AuditLogSessionScalarFieldEnum.schema.ts
export const AuditLogSessionScalarFieldEnumSchema = z.enum(['id', 'installationId', 'userId', 'fingerprint', 'platform', 'platformDetails', 'systemDetails', 'createdAt']);
// File: AuditLogScalarFieldEnum.schema.ts
export const AuditLogScalarFieldEnumSchema = z.enum(['id', 'sessionId', 'context', 'type', 'ipAddress', 'proctoringSessionId', 'liveSessionId', 'details', 'time', 'createdAt']);
// File: LiveSessionScalarFieldEnum.schema.ts
export const LiveSessionScalarFieldEnumSchema = z.enum(['id', 'assessmentId', 'liveProvidedSessionId', 'status', 'name', 'startTime', 'endTime', 'capacity', 'demoMode', 'createdAt', 'updatedAt']);
// File: LiveSessionStudentScalarFieldEnum.schema.ts
export const LiveSessionStudentScalarFieldEnumSchema = z.enum(['id', 'liveSessionId', 'instituteUserId', 'joined', 'createdAt', 'updatedAt']);
// File: ProctorGroupScalarFieldEnum.schema.ts
export const ProctorGroupScalarFieldEnumSchema = z.enum(['id', 'name', 'ownerInstituteId', 'createdAt', 'updatedAt']);
// File: ProctorGroupAllowedInstituteScalarFieldEnum.schema.ts
export const ProctorGroupAllowedInstituteScalarFieldEnumSchema = z.enum(['id', 'proctorGroupId', 'instituteId', 'minHoursNotice', 'hoursNotAcceptedNotify', 'hoursTrackCancellation', 'trackCancellationMessage', 'createdAt', 'updatedAt']);
// File: ProctorGroupProctorScalarFieldEnum.schema.ts
export const ProctorGroupProctorScalarFieldEnumSchema = z.enum(['id', 'userId', 'proctorGroupId', 'createdAt', 'updatedAt']);
// File: ProctorGroupAdminScalarFieldEnum.schema.ts
export const ProctorGroupAdminScalarFieldEnumSchema = z.enum(['id', 'userId', 'proctorGroupId', 'createdAt', 'updatedAt']);
// File: ProctorAvailabilityScalarFieldEnum.schema.ts
export const ProctorAvailabilityScalarFieldEnumSchema = z.enum(['id', 'userId', 'availability', 'createdAt', 'updatedAt']);
// File: LiveSessionProctorScalarFieldEnum.schema.ts
export const LiveSessionProctorScalarFieldEnumSchema = z.enum(['id', 'liveSessionId', 'instituteUserId', 'joined', 'createdAt', 'updatedAt']);
// File: LiveSessionProctorGroupScalarFieldEnum.schema.ts
export const LiveSessionProctorGroupScalarFieldEnumSchema = z.enum(['id', 'liveSessionId', 'proctorGroupId', 'selectedProctorId', 'joined', 'checkProctorAt', 'createdAt', 'updatedAt']);
// File: LiveSessionNoteScalarFieldEnum.schema.ts
export const LiveSessionNoteScalarFieldEnumSchema = z.enum(['id', 'liveSessionId', 'studentInstituteUserId', 'createdAt', 'updatedAt']);
// File: LiveSessionNoteEditScalarFieldEnum.schema.ts
export const LiveSessionNoteEditScalarFieldEnumSchema = z.enum(['id', 'liveSessionId', 'liveSessionNoteId', 'editorId', 'editorInstituteUserId', 'content', 'createdAt', 'updatedAt']);
// File: CancelledLiveSessionScalarFieldEnum.schema.ts
export const CancelledLiveSessionScalarFieldEnumSchema = z.enum(['id', 'liveSessionId', 'assessmentId', 'assessmentName', 'courseId', 'courseName', 'instituteId', 'instituteName', 'name', 'startTime', 'endTime', 'capacity', 'sessionCreatedAt', 'sessionUpdatedAt', 'cancelledAt', 'recordUpdatedAt']);
// File: CancelledLiveSessionProctorGroupScalarFieldEnum.schema.ts
export const CancelledLiveSessionProctorGroupScalarFieldEnumSchema = z.enum(['id', 'cancelledLiveSessionId', 'proctorGroupId', 'selectedProctorId', 'createdAt', 'updatedAt']);
// File: CourseEmailSettingsScalarFieldEnum.schema.ts
export const CourseEmailSettingsScalarFieldEnumSchema = z.enum(['id', 'instituteUserId', 'courseId', 'createdAt', 'updatedAt']);
// File: CourseSettingsScalarFieldEnum.schema.ts
export const CourseSettingsScalarFieldEnumSchema = z.enum(['id', 'courseId', 'allowStopRecording', 'geofenceLocations', 'createdAt', 'updatedAt']);
// File: ThirdPartyPlatformScalarFieldEnum.schema.ts
export const ThirdPartyPlatformScalarFieldEnumSchema = z.enum(['id', 'name']);
// File: InstituteAndThirdPartyPlatformsScalarFieldEnum.schema.ts
export const InstituteAndThirdPartyPlatformsScalarFieldEnumSchema = z.enum(['id', 'instituteId', 'platformId']);
// File: InstituteSettingsScalarFieldEnum.schema.ts
export const InstituteSettingsScalarFieldEnumSchema = z.enum(['id', 'instituteId', 'allowStopRecording', 'policyStatementFileName', 'defaultProctoringOptionProfileId', 'disabledProctoringOptions', 'allowStrictMode', 'suffix', 'createdAt', 'updatedAt', 'scopeSettingsMode', 'lockdownRequireManagedGuestSession', 'managedGuestSessionRequireIncognito', 'delayRecordingUntilAssessmentStart', 'allowPortalMadeThirdPartyAssessments', 'flaggedKeywords', 'allowQuizAttemptOnChrome', 'allowQuizAttemptOnFirefox', 'allowQuizAttemptOnSafari', 'recordingMaxAgeMonths', 'sessionRecordingLimitHours', 'proctoringRegistrationNotifications', 'preferredProctoringSetupUiVersion', 'dailyDigestEmailEnabled', 'platformChatEnabled']);
// File: UserSettingsScalarFieldEnum.schema.ts
export const UserSettingsScalarFieldEnumSchema = z.enum(['id', 'instituteUserId', 'language', 'createdAt', 'updatedAt']);
// File: TemporaryAccessCodeScalarFieldEnum.schema.ts
export const TemporaryAccessCodeScalarFieldEnumSchema = z.enum(['accessCode', 'userId', 'data', 'createdAt']);
// File: StandaloneStudentInfoScalarFieldEnum.schema.ts
export const StandaloneStudentInfoScalarFieldEnumSchema = z.enum(['id', 'userId', 'accessCode', 'email', 'firstName', 'lastName', 'data', 'createdAt', 'expiryDate', 'lmsQuizId', 'accountId']);
// File: LmsCourseAnomalyConfigScalarFieldEnum.schema.ts
export const LmsCourseAnomalyConfigScalarFieldEnumSchema = z.enum(['id', 'lmsCourseId', 'setting', 'createdAt', 'updatedAt']);
// File: ProctoringSessionStateScalarFieldEnum.schema.ts
export const ProctoringSessionStateScalarFieldEnumSchema = z.enum(['id', 'proctoringSessionId', 'status', 'createdAt', 'updatedAt']);
// File: ProctoringSessionNoteScalarFieldEnum.schema.ts
export const ProctoringSessionNoteScalarFieldEnumSchema = z.enum(['id', 'proctoringSessionId', 'content', 'timestamp', 'createdAt', 'updatedAt']);
// File: ProctoringRoomScanNoteScalarFieldEnum.schema.ts
export const ProctoringRoomScanNoteScalarFieldEnumSchema = z.enum(['id', 'proctoringSessionId', 'content', 'timestamp', 'createdAt', 'updatedAt']);
// File: ExtensionInstallationScalarFieldEnum.schema.ts
export const ExtensionInstallationScalarFieldEnumSchema = z.enum(['id', 'instanceId', 'userId', 'isUpdate', 'time', 'details', 'createdAt', 'updatedAt']);
// File: BlackboardAuthorizationRequestScalarFieldEnum.schema.ts
export const BlackboardAuthorizationRequestScalarFieldEnumSchema = z.enum(['id', 'accountId', 'refreshToken', 'lmsOrigin', 'redirectUri', 'codeVerifier', 'state', 'createdDate', 'expiryDate']);
// File: InstituteUpdateLogScalarFieldEnum.schema.ts
export const InstituteUpdateLogScalarFieldEnumSchema = z.enum(['id', 'accountId', 'userId', 'details', 'timestamp']);
// File: ApplicationsScalarFieldEnum.schema.ts
export const ApplicationsScalarFieldEnumSchema = z.enum(['id', 'name', 'processName', 'iconSvg', 'type', 'createdAt', 'updatedAt']);
// File: ExtensionsScalarFieldEnum.schema.ts
export const ExtensionsScalarFieldEnumSchema = z.enum(['id', 'extensionId', 'extensionName', 'iconSvg', 'type', 'createdAt', 'updatedAt']);
// File: SubAccountsScalarFieldEnum.schema.ts
export const SubAccountsScalarFieldEnumSchema = z.enum(['id', 'accountName', 'instituteId', 'lmsAccountId', 'lmsAccountUuid', 'parentLmsAccountId', 'rootLmsAccountId', 'lmsAccountState', 'verityEnabled', 'createdAt', 'updatedAt']);
// File: ProctoringSessionReportScalarFieldEnum.schema.ts
export const ProctoringSessionReportScalarFieldEnumSchema = z.enum(['proctoringSessionId', 'studentId', 'studentName', 'quizId', 'quizName', 'lmsCourseId', 'instituteId', 'type', 'noneFlagCount', 'minorFlagCount', 'majorFlagCount', 'severeFlagCount', 'secondsProctored', 'sessionStartTime', 'anomalyTypeCount', 'createdAt', 'updatedAt']);
// File: InstituteReportScalarFieldEnum.schema.ts
export const InstituteReportScalarFieldEnumSchema = z.enum(['id', 'instituteId', 'startDate', 'endDate', 'uniqueStudents', 'uniqueAssessments', 'totalSessions', 'totalLiveSessions', 'totalLiveCheckInSessions', 'totalProctoringHours', 'totalLiveHours', 'averageIntegrityScore', 'anomalyTypeCount', 'courseTableData', 'createdAt', 'updatedAt']);
// File: InstituteReportSummaryScalarFieldEnum.schema.ts
export const InstituteReportSummaryScalarFieldEnumSchema = z.enum(['id', 'instituteId', 'startDate', 'endDate', 'summary', 'createdAt', 'updatedAt']);
// File: InstitutionReportEmailScalarFieldEnum.schema.ts
export const InstitutionReportEmailScalarFieldEnumSchema = z.enum(['id', 'institutionId', 'month', 'year', 'adminEmails', 'topMetrics', 'title', 'summary', 'isApproved', 'isSent', 'createdAt', 'updatedAt']);
// File: ExemptedInstitutionReportEmailUsersScalarFieldEnum.schema.ts
export const ExemptedInstitutionReportEmailUsersScalarFieldEnumSchema = z.enum(['id', 'userId', 'createdAt', 'updatedAt']);
// File: SubAccountReportScalarFieldEnum.schema.ts
export const SubAccountReportScalarFieldEnumSchema = z.enum(['id', 'subAccountId', 'instituteId', 'startDate', 'endDate', 'uniqueStudents', 'uniqueAssessments', 'totalSessions', 'totalLiveSessions', 'totalLiveCheckInSessions', 'totalProctoringHours', 'totalLiveHours', 'averageIntegrityScore', 'anomalyTypeCount', 'courseTableData', 'createdAt', 'updatedAt']);
// File: SubAccountReportSummaryScalarFieldEnum.schema.ts
export const SubAccountReportSummaryScalarFieldEnumSchema = z.enum(['id', 'subAccountId', 'startDate', 'endDate', 'summary', 'createdAt', 'updatedAt']);
// File: CourseReportScalarFieldEnum.schema.ts
export const CourseReportScalarFieldEnumSchema = z.enum(['id', 'courseId', 'startDate', 'endDate', 'uniqueStudents', 'uniqueAssessments', 'totalSessions', 'totalLiveSessions', 'totalLiveCheckInSessions', 'totalProctoringHours', 'totalLiveHours', 'averageIntegrityScore', 'anomalyTypeCount', 'assessmentTableData', 'createdAt', 'updatedAt']);
// File: CourseReportSummaryScalarFieldEnum.schema.ts
export const CourseReportSummaryScalarFieldEnumSchema = z.enum(['id', 'courseId', 'startDate', 'endDate', 'summary', 'createdAt', 'updatedAt']);
// File: MoodleAccessTokenScalarFieldEnum.schema.ts
export const MoodleAccessTokenScalarFieldEnumSchema = z.enum(['id', 'instituteId', 'accessToken']);
// File: SocketSessionScalarFieldEnum.schema.ts
export const SocketSessionScalarFieldEnumSchema = z.enum(['id', 'proctoringSessionUuid', 'createdAt']);
// File: SocketEventScalarFieldEnum.schema.ts
export const SocketEventScalarFieldEnumSchema = z.enum(['id', 'socketSessionId', 'name', 'createdAt', 'ackedAt']);
// File: LmsTokenAuthorizationRequestScalarFieldEnum.schema.ts
export const LmsTokenAuthorizationRequestScalarFieldEnumSchema = z.enum(['id', 'state', 'userId', 'courseId', 'callbackUrl', 'createdAt']);
// File: ScratchNoteScalarFieldEnum.schema.ts
export const ScratchNoteScalarFieldEnumSchema = z.enum(['id', 'proctoringSessionUuid', 'mimeType', 'createdAt', 'uploadedAt']);
// File: ApiRouteConfigScalarFieldEnum.schema.ts
export const ApiRouteConfigScalarFieldEnumSchema = z.enum(['id', 'version', 'route', 'instituteId', 'active', 'createdAt', 'updatedAt']);
// File: RecordingScalarFieldEnum.schema.ts
export const RecordingScalarFieldEnumSchema = z.enum(['id', 'proctoringSessionId', 'recordingId', 'sourceIndex', 'type', 'chunked', 'createdAt', 'updatedAt']);
// File: RecordingConcatenationRequestScalarFieldEnum.schema.ts
export const RecordingConcatenationRequestScalarFieldEnumSchema = z.enum(['proctoringSessionId', 'type', 'number', 'requestId', 'status', 'createdAt', 'updatedAt']);
// File: RuleScalarFieldEnum.schema.ts
export const RuleScalarFieldEnumSchema = z.enum(['id', 'instituteId', 'scope', 'scopeValue', 'type', 'details', 'order', 'enabled', 'createdAt', 'updatedAt']);
// File: TemporaryEnabledCourseScalarFieldEnum.schema.ts
export const TemporaryEnabledCourseScalarFieldEnumSchema = z.enum(['id', 'courseId', 'instituteId']);
// File: ProctoringSessionDataDumpScalarFieldEnum.schema.ts
export const ProctoringSessionDataDumpScalarFieldEnumSchema = z.enum(['id', 'proctoringSessionId', 'source', 'mimeType', 'createdAt', 'uploadedAt']);
// File: InstitutionPaymentOptionsScalarFieldEnum.schema.ts
export const InstitutionPaymentOptionsScalarFieldEnumSchema = z.enum(['id', 'currency', 'instituteId', 'automatedType', 'liveProctoringType', 'liveCheckInType', 'livePostReviewType', 'livePostReviewPrice', 'liveCheckInPrice', 'liveProctoringPrice', 'automatedProctoringPrice', 'enabled', 'createdAt', 'updatedAt']);
// File: StripePaymentSessionScalarFieldEnum.schema.ts
export const StripePaymentSessionScalarFieldEnumSchema = z.enum(['id', 'assessmentId', 'userId', 'proctoringSessionId', 'stripeSessionId', 'paid', 'claimed', 'createdAt', 'updatedAt']);
// File: RestrictedDevicePeerScalarFieldEnum.schema.ts
export const RestrictedDevicePeerScalarFieldEnumSchema = z.enum(['id', 'proctoringSessionId', 'role', 'platform', 'options']);
// File: RestrictedDeviceStateScalarFieldEnum.schema.ts
export const RestrictedDeviceStateScalarFieldEnumSchema = z.enum(['id', 'peerId', 'connected', 'data', 'createdAt', 'updatedAt']);
// File: RestrictedDeviceSingleUseGrantScalarFieldEnum.schema.ts
export const RestrictedDeviceSingleUseGrantScalarFieldEnumSchema = z.enum(['id', 'peerId', 'secret', 'accountId', 'createdAt']);
// File: FeedbackScalarFieldEnum.schema.ts
export const FeedbackScalarFieldEnumSchema = z.enum(['id', 'userId', 'satisfaction', 'category', 'summary', 'details', 'status', 'isDeleted', 'createdAt', 'updatedAt']);
// File: EventBannerScalarFieldEnum.schema.ts
export const EventBannerScalarFieldEnumSchema = z.enum(['id', 'createdBy', 'title', 'link', 'buttonText', 'institutions', 'roles', 'startDate', 'endDate', 'isDeleted', 'createdAt', 'updatedAt']);
// File: InferenceTokenScalarFieldEnum.schema.ts
export const InferenceTokenScalarFieldEnumSchema = z.enum(['id', 'proctoringSessionId', 'data', 'createdAt', 'updatedAt']);
// File: InstituteStateScalarFieldEnum.schema.ts
export const InstituteStateScalarFieldEnumSchema = z.enum(['instituteId', 'lastVisualizerLaunchTime', 'lastLti1p3LaunchTime', 'ltiQuickLinkTemplate', 'ltiQuickLinkTemplateAt', 'createdAt', 'updatedAt']);
// File: InstituteSetupGuideScalarFieldEnum.schema.ts
export const InstituteSetupGuideScalarFieldEnumSchema = z.enum(['instituteId', 'setupProfileId', 'setupQuizId', 'takeStepUserId', 'lti1p3SetupComplete', 'visualizerSetupComplete', 'apiSetupComplete', 'profileSetupComplete', 'extensionSetupComplete', 'createSetupComplete', 'takeSetupComplete', 'resultSetupComplete', 'createdAt', 'updatedAt']);
// File: ProctoringSessionSummaryScalarFieldEnum.schema.ts
export const ProctoringSessionSummaryScalarFieldEnumSchema = z.enum(['id', 'proctoringSessionId', 'source', 'summary', 'authorId', 'createdAt', 'updatedAt']);
// File: SetupSupportChatMessageScalarFieldEnum.schema.ts
export const SetupSupportChatMessageScalarFieldEnumSchema = z.enum(['id', 'proctoringSessionId', 'fromUser', 'timestamp', 'message']);
// File: CandidateInterviewOptionsScalarFieldEnum.schema.ts
export const CandidateInterviewOptionsScalarFieldEnumSchema = z.enum(['id', 'title', 'candidateName', 'candidateEmail', 'positionName', 'videoPlatform', 'meetingLink', 'notes', 'proctoringAssessmentConfigurationId']);
// File: CronExpireRecordingScalarFieldEnum.schema.ts
export const CronExpireRecordingScalarFieldEnumSchema = z.enum(['id', 'instituteId', 'lastProcessedId', 'startedAt', 'updatedAt', 'stoppedAt']);
// File: QuizQuestionScalarFieldEnum.schema.ts
export const QuizQuestionScalarFieldEnumSchema = z.enum(['id', 'quizId', 'questionText', 'questionOrder', 'questionType', 'correctionPoints', 'options', 'configuration', 'isDeleted', 'aiGradingEnabled', 'aiGradingCriteria', 'createdAt', 'updatedAt']);
// File: QuizResponseScalarFieldEnum.schema.ts
export const QuizResponseScalarFieldEnumSchema = z.enum(['id', 'sessionId', 'questionSnapshot', 'questionNo', 'answer', 'isAnswered', 'createdAt', 'updatedAt']);
// File: QuizResponseGradeScalarFieldEnum.schema.ts
export const QuizResponseGradeScalarFieldEnumSchema = z.enum(['id', 'responseId', 'score', 'notes', 'isDraft', 'isGraded', 'gradedByAi', 'aiJustification', 'createdAt', 'updatedAt']);
// File: FingerprintsScalarFieldEnum.schema.ts
export const FingerprintsScalarFieldEnumSchema = z.enum(['id', 'fingerprint', 'questionId', 'responseId', 'wordOffset', 'createdAt', 'updatedAt']);
// File: SortOrder.schema.ts
export const SortOrderSchema = z.enum(['asc', 'desc']);
// File: JsonNullValueInput.schema.ts
export const JsonNullValueInputSchema = z.enum(['JsonNull']);
// File: NullableJsonNullValueInput.schema.ts
export const NullableJsonNullValueInputSchema = z.enum(['DbNull', 'JsonNull']);
// File: JsonNullValueFilter.schema.ts
export const JsonNullValueFilterSchema = z.enum(['DbNull', 'JsonNull', 'AnyNull']);
// File: QueryMode.schema.ts
export const QueryModeSchema = z.enum(['default', 'insensitive']);
// File: GlobalSettingOrderByRelevanceFieldEnum.schema.ts
export const GlobalSettingOrderByRelevanceFieldEnumSchema = z.enum(['key']);
// File: ResourceOrderByRelevanceFieldEnum.schema.ts
export const ResourceOrderByRelevanceFieldEnumSchema = z.enum(['name']);
// File: RoleOrderByRelevanceFieldEnum.schema.ts
export const RoleOrderByRelevanceFieldEnumSchema = z.enum(['name']);
// File: NullsOrder.schema.ts
export const NullsOrderSchema = z.enum(['first', 'last']);
// File: LmsCourseOrderByRelevanceFieldEnum.schema.ts
export const LmsCourseOrderByRelevanceFieldEnumSchema = z.enum(['courseId', 'accessControlUuid']);
// File: LmsQuizOrderByRelevanceFieldEnum.schema.ts
export const LmsQuizOrderByRelevanceFieldEnumSchema = z.enum(['quizId']);
// File: VerityAssessmentOrderByRelevanceFieldEnum.schema.ts
export const VerityAssessmentOrderByRelevanceFieldEnumSchema = z.enum(['description', 'moduleId']);
// File: AssessmentQuestionOrderByRelevanceFieldEnum.schema.ts
export const AssessmentQuestionOrderByRelevanceFieldEnumSchema = z.enum(['lmsProvidedQuestionId', 'title', 'bodyHtml', 'bodyText', 'decoySiteHostname', 'decoySitePostId']);
// File: QuestionSourcesOrderByRelevanceFieldEnum.schema.ts
export const QuestionSourcesOrderByRelevanceFieldEnumSchema = z.enum(['hostname', 'email']);
// File: LmsQuizCacheOrderByRelevanceFieldEnum.schema.ts
export const LmsQuizCacheOrderByRelevanceFieldEnumSchema = z.enum(['quizId', 'activityUrl']);
// File: LmsQuizCopyCheckedOrderByRelevanceFieldEnum.schema.ts
export const LmsQuizCopyCheckedOrderByRelevanceFieldEnumSchema = z.enum(['lmsCourseId', 'quizId']);
// File: Lti1p3InstituteOrderByRelevanceFieldEnum.schema.ts
export const Lti1p3InstituteOrderByRelevanceFieldEnumSchema = z.enum(['instituteName', 'lms', 'language', 'origin', 'ltiClientId', 'lmsApiClientId', 'lmsApiClientSecret', 'deploymentId', 'accessControlUuid']);
// File: InstitutePendingDeletionOrderByRelevanceFieldEnum.schema.ts
export const InstitutePendingDeletionOrderByRelevanceFieldEnumSchema = z.enum(['initiatingUserId', 'initiatingUserName', 'initiatingUserEmail']);
// File: LuminaPartnerKeyOrderByRelevanceFieldEnum.schema.ts
export const LuminaPartnerKeyOrderByRelevanceFieldEnumSchema = z.enum(['keyId', 'keyHash', 'label']);
// File: LuminaResultsTokenOrderByRelevanceFieldEnum.schema.ts
export const LuminaResultsTokenOrderByRelevanceFieldEnumSchema = z.enum(['tokenId']);
// File: LtiDeploymentHostnameOrderByRelevanceFieldEnum.schema.ts
export const LtiDeploymentHostnameOrderByRelevanceFieldEnumSchema = z.enum(['hostname']);
// File: Lti1p3IssOrderByRelevanceFieldEnum.schema.ts
export const Lti1p3IssOrderByRelevanceFieldEnumSchema = z.enum(['iss', 'platformOidcEndpoint', 'platformJwksEndpoint']);
// File: ProctoringExemptionOrderByRelevanceFieldEnum.schema.ts
export const ProctoringExemptionOrderByRelevanceFieldEnumSchema = z.enum(['accommodationNotes']);
// File: InstitutionProctoringAccommodationOrderByRelevanceFieldEnum.schema.ts
export const InstitutionProctoringAccommodationOrderByRelevanceFieldEnumSchema = z.enum(['accommodationNotes']);
// File: LmsTokenOrderByRelevanceFieldEnum.schema.ts
export const LmsTokenOrderByRelevanceFieldEnumSchema = z.enum(['accessToken', 'refreshToken']);
// File: ThirdPartyAssessmentOptionOrderByRelevanceFieldEnum.schema.ts
export const ThirdPartyAssessmentOptionOrderByRelevanceFieldEnumSchema = z.enum(['thirdPartyUrl', 'password']);
// File: ProctoringAssessmentConfigurationOrderByRelevanceFieldEnum.schema.ts
export const ProctoringAssessmentConfigurationOrderByRelevanceFieldEnumSchema = z.enum(['password']);
// File: ProctoringOptionProfileOrderByRelevanceFieldEnum.schema.ts
export const ProctoringOptionProfileOrderByRelevanceFieldEnumSchema = z.enum(['name']);
// File: VerityInstituteSettingsOrderByRelevanceFieldEnum.schema.ts
export const VerityInstituteSettingsOrderByRelevanceFieldEnumSchema = z.enum(['salesforceId']);
// File: InstituteUsageLimitOrderByRelevanceFieldEnum.schema.ts
export const InstituteUsageLimitOrderByRelevanceFieldEnumSchema = z.enum(['proctorGroupId']);
// File: InstituteUsageCacheOrderByRelevanceFieldEnum.schema.ts
export const InstituteUsageCacheOrderByRelevanceFieldEnumSchema = z.enum(['proctorGroupId']);
// File: InstituteUsageUserCacheOrderByRelevanceFieldEnum.schema.ts
export const InstituteUsageUserCacheOrderByRelevanceFieldEnumSchema = z.enum(['proctorGroupId']);
// File: LiveSessionUsageCacheOrderByRelevanceFieldEnum.schema.ts
export const LiveSessionUsageCacheOrderByRelevanceFieldEnumSchema = z.enum(['id']);
// File: ProctoringSessionOrderByRelevanceFieldEnum.schema.ts
export const ProctoringSessionOrderByRelevanceFieldEnumSchema = z.enum(['uuid', 'liveSessionId', 'liveUserSessionId', 'ipAddress', 'webcamAndScreenCaptureDeleteCause', 'roomScanDeleteCause']);
// File: DemoSessionOrderByRelevanceFieldEnum.schema.ts
export const DemoSessionOrderByRelevanceFieldEnumSchema = z.enum(['id', 'email', 'firstName', 'lastName', 'organization', 'role', 'verificationTokenHash', 'demoSessionTokenHash', 'accessControlAccountId', 'proctoringSessionUuid', 'resultTokenHash', 'resultEmailTokenCiphertext']);
// File: ProctoringSessionAnomaliesOrderByRelevanceFieldEnum.schema.ts
export const ProctoringSessionAnomaliesOrderByRelevanceFieldEnumSchema = z.enum(['type', 'comment']);
// File: ProctoringSessionEventOrderByRelevanceFieldEnum.schema.ts
export const ProctoringSessionEventOrderByRelevanceFieldEnumSchema = z.enum(['type', 'name']);
// File: UserOrderByRelevanceFieldEnum.schema.ts
export const UserOrderByRelevanceFieldEnumSchema = z.enum(['lmsProvidedUserId', 'name', 'accessControlUuid', 'stripeUserId']);
// File: UserSessionOrderByRelevanceFieldEnum.schema.ts
export const UserSessionOrderByRelevanceFieldEnumSchema = z.enum(['sid']);
// File: UserStateOrderByRelevanceFieldEnum.schema.ts
export const UserStateOrderByRelevanceFieldEnumSchema = z.enum(['activeSetupStep']);
// File: YujaAccountOrderByRelevanceFieldEnum.schema.ts
export const YujaAccountOrderByRelevanceFieldEnumSchema = z.enum(['username', 'password']);
// File: YujaAccountRoleOrderByRelevanceFieldEnum.schema.ts
export const YujaAccountRoleOrderByRelevanceFieldEnumSchema = z.enum(['role']);
// File: YujaDebugInstanceOrderByRelevanceFieldEnum.schema.ts
export const YujaDebugInstanceOrderByRelevanceFieldEnumSchema = z.enum(['uuid']);
// File: YujaDebugStatisticOrderByRelevanceFieldEnum.schema.ts
export const YujaDebugStatisticOrderByRelevanceFieldEnumSchema = z.enum(['type']);
// File: InstallationOrderByRelevanceFieldEnum.schema.ts
export const InstallationOrderByRelevanceFieldEnumSchema = z.enum(['id', 'version', 'fingerprint']);
// File: AuditLogSessionOrderByRelevanceFieldEnum.schema.ts
export const AuditLogSessionOrderByRelevanceFieldEnumSchema = z.enum(['installationId', 'userId', 'fingerprint']);
// File: AuditLogOrderByRelevanceFieldEnum.schema.ts
export const AuditLogOrderByRelevanceFieldEnumSchema = z.enum(['type', 'ipAddress', 'proctoringSessionId', 'liveSessionId']);
// File: LiveSessionOrderByRelevanceFieldEnum.schema.ts
export const LiveSessionOrderByRelevanceFieldEnumSchema = z.enum(['liveProvidedSessionId', 'name']);
// File: ProctorGroupOrderByRelevanceFieldEnum.schema.ts
export const ProctorGroupOrderByRelevanceFieldEnumSchema = z.enum(['name']);
// File: ProctorGroupAllowedInstituteOrderByRelevanceFieldEnum.schema.ts
export const ProctorGroupAllowedInstituteOrderByRelevanceFieldEnumSchema = z.enum(['trackCancellationMessage']);
// File: ProctorGroupProctorOrderByRelevanceFieldEnum.schema.ts
export const ProctorGroupProctorOrderByRelevanceFieldEnumSchema = z.enum(['userId']);
// File: ProctorGroupAdminOrderByRelevanceFieldEnum.schema.ts
export const ProctorGroupAdminOrderByRelevanceFieldEnumSchema = z.enum(['userId']);
// File: ProctorAvailabilityOrderByRelevanceFieldEnum.schema.ts
export const ProctorAvailabilityOrderByRelevanceFieldEnumSchema = z.enum(['userId']);
// File: LiveSessionProctorGroupOrderByRelevanceFieldEnum.schema.ts
export const LiveSessionProctorGroupOrderByRelevanceFieldEnumSchema = z.enum(['selectedProctorId']);
// File: LiveSessionNoteEditOrderByRelevanceFieldEnum.schema.ts
export const LiveSessionNoteEditOrderByRelevanceFieldEnumSchema = z.enum(['editorId', 'content']);
// File: CancelledLiveSessionOrderByRelevanceFieldEnum.schema.ts
export const CancelledLiveSessionOrderByRelevanceFieldEnumSchema = z.enum(['assessmentName', 'courseName', 'instituteName', 'name']);
// File: CancelledLiveSessionProctorGroupOrderByRelevanceFieldEnum.schema.ts
export const CancelledLiveSessionProctorGroupOrderByRelevanceFieldEnumSchema = z.enum(['selectedProctorId']);
// File: ThirdPartyPlatformOrderByRelevanceFieldEnum.schema.ts
export const ThirdPartyPlatformOrderByRelevanceFieldEnumSchema = z.enum(['name']);
// File: InstituteSettingsOrderByRelevanceFieldEnum.schema.ts
export const InstituteSettingsOrderByRelevanceFieldEnumSchema = z.enum(['policyStatementFileName', 'suffix']);
// File: TemporaryAccessCodeOrderByRelevanceFieldEnum.schema.ts
export const TemporaryAccessCodeOrderByRelevanceFieldEnumSchema = z.enum(['accessCode']);
// File: StandaloneStudentInfoOrderByRelevanceFieldEnum.schema.ts
export const StandaloneStudentInfoOrderByRelevanceFieldEnumSchema = z.enum(['accessCode', 'email', 'firstName', 'lastName', 'accountId']);
// File: ProctoringSessionStateOrderByRelevanceFieldEnum.schema.ts
export const ProctoringSessionStateOrderByRelevanceFieldEnumSchema = z.enum(['status']);
// File: ProctoringSessionNoteOrderByRelevanceFieldEnum.schema.ts
export const ProctoringSessionNoteOrderByRelevanceFieldEnumSchema = z.enum(['content']);
// File: ProctoringRoomScanNoteOrderByRelevanceFieldEnum.schema.ts
export const ProctoringRoomScanNoteOrderByRelevanceFieldEnumSchema = z.enum(['content']);
// File: BlackboardAuthorizationRequestOrderByRelevanceFieldEnum.schema.ts
export const BlackboardAuthorizationRequestOrderByRelevanceFieldEnumSchema = z.enum(['accountId', 'refreshToken', 'lmsOrigin', 'redirectUri', 'codeVerifier', 'state']);
// File: InstituteUpdateLogOrderByRelevanceFieldEnum.schema.ts
export const InstituteUpdateLogOrderByRelevanceFieldEnumSchema = z.enum(['accountId', 'userId']);
// File: ApplicationsOrderByRelevanceFieldEnum.schema.ts
export const ApplicationsOrderByRelevanceFieldEnumSchema = z.enum(['name', 'iconSvg', 'type']);
// File: ExtensionsOrderByRelevanceFieldEnum.schema.ts
export const ExtensionsOrderByRelevanceFieldEnumSchema = z.enum(['extensionId', 'extensionName', 'iconSvg', 'type']);
// File: SubAccountsOrderByRelevanceFieldEnum.schema.ts
export const SubAccountsOrderByRelevanceFieldEnumSchema = z.enum(['accountName', 'lmsAccountId', 'lmsAccountUuid', 'parentLmsAccountId', 'rootLmsAccountId', 'lmsAccountState']);
// File: ProctoringSessionReportOrderByRelevanceFieldEnum.schema.ts
export const ProctoringSessionReportOrderByRelevanceFieldEnumSchema = z.enum(['studentName', 'quizName']);
// File: InstitutionReportEmailOrderByRelevanceFieldEnum.schema.ts
export const InstitutionReportEmailOrderByRelevanceFieldEnumSchema = z.enum(['title', 'summary']);
// File: MoodleAccessTokenOrderByRelevanceFieldEnum.schema.ts
export const MoodleAccessTokenOrderByRelevanceFieldEnumSchema = z.enum(['accessToken']);
// File: SocketSessionOrderByRelevanceFieldEnum.schema.ts
export const SocketSessionOrderByRelevanceFieldEnumSchema = z.enum(['proctoringSessionUuid']);
// File: SocketEventOrderByRelevanceFieldEnum.schema.ts
export const SocketEventOrderByRelevanceFieldEnumSchema = z.enum(['name']);
// File: LmsTokenAuthorizationRequestOrderByRelevanceFieldEnum.schema.ts
export const LmsTokenAuthorizationRequestOrderByRelevanceFieldEnumSchema = z.enum(['state', 'callbackUrl']);
// File: ScratchNoteOrderByRelevanceFieldEnum.schema.ts
export const ScratchNoteOrderByRelevanceFieldEnumSchema = z.enum(['id', 'proctoringSessionUuid']);
// File: ApiRouteConfigOrderByRelevanceFieldEnum.schema.ts
export const ApiRouteConfigOrderByRelevanceFieldEnumSchema = z.enum(['route']);
// File: RecordingOrderByRelevanceFieldEnum.schema.ts
export const RecordingOrderByRelevanceFieldEnumSchema = z.enum(['recordingId']);
// File: RecordingConcatenationRequestOrderByRelevanceFieldEnum.schema.ts
export const RecordingConcatenationRequestOrderByRelevanceFieldEnumSchema = z.enum(['type', 'requestId']);
// File: RuleOrderByRelevanceFieldEnum.schema.ts
export const RuleOrderByRelevanceFieldEnumSchema = z.enum(['scopeValue']);
// File: TemporaryEnabledCourseOrderByRelevanceFieldEnum.schema.ts
export const TemporaryEnabledCourseOrderByRelevanceFieldEnumSchema = z.enum(['courseId']);
// File: ProctoringSessionDataDumpOrderByRelevanceFieldEnum.schema.ts
export const ProctoringSessionDataDumpOrderByRelevanceFieldEnumSchema = z.enum(['id', 'source', 'mimeType']);
// File: InstitutionPaymentOptionsOrderByRelevanceFieldEnum.schema.ts
export const InstitutionPaymentOptionsOrderByRelevanceFieldEnumSchema = z.enum(['currency']);
// File: StripePaymentSessionOrderByRelevanceFieldEnum.schema.ts
export const StripePaymentSessionOrderByRelevanceFieldEnumSchema = z.enum(['stripeSessionId']);
// File: RestrictedDevicePeerOrderByRelevanceFieldEnum.schema.ts
export const RestrictedDevicePeerOrderByRelevanceFieldEnumSchema = z.enum(['id']);
// File: RestrictedDeviceStateOrderByRelevanceFieldEnum.schema.ts
export const RestrictedDeviceStateOrderByRelevanceFieldEnumSchema = z.enum(['peerId']);
// File: RestrictedDeviceSingleUseGrantOrderByRelevanceFieldEnum.schema.ts
export const RestrictedDeviceSingleUseGrantOrderByRelevanceFieldEnumSchema = z.enum(['peerId', 'secret', 'accountId']);
// File: FeedbackOrderByRelevanceFieldEnum.schema.ts
export const FeedbackOrderByRelevanceFieldEnumSchema = z.enum(['summary', 'details']);
// File: EventBannerOrderByRelevanceFieldEnum.schema.ts
export const EventBannerOrderByRelevanceFieldEnumSchema = z.enum(['title', 'link', 'buttonText']);
// File: InferenceTokenOrderByRelevanceFieldEnum.schema.ts
export const InferenceTokenOrderByRelevanceFieldEnumSchema = z.enum(['id', 'data']);
// File: InstituteStateOrderByRelevanceFieldEnum.schema.ts
export const InstituteStateOrderByRelevanceFieldEnumSchema = z.enum(['ltiQuickLinkTemplate']);
// File: ProctoringSessionSummaryOrderByRelevanceFieldEnum.schema.ts
export const ProctoringSessionSummaryOrderByRelevanceFieldEnumSchema = z.enum(['authorId']);
// File: SetupSupportChatMessageOrderByRelevanceFieldEnum.schema.ts
export const SetupSupportChatMessageOrderByRelevanceFieldEnumSchema = z.enum(['message']);
// File: CandidateInterviewOptionsOrderByRelevanceFieldEnum.schema.ts
export const CandidateInterviewOptionsOrderByRelevanceFieldEnumSchema = z.enum(['title', 'candidateName', 'candidateEmail', 'positionName', 'meetingLink', 'notes']);
// File: QuizQuestionOrderByRelevanceFieldEnum.schema.ts
export const QuizQuestionOrderByRelevanceFieldEnumSchema = z.enum(['questionText', 'aiGradingCriteria']);
// File: QuizResponseGradeOrderByRelevanceFieldEnum.schema.ts
export const QuizResponseGradeOrderByRelevanceFieldEnumSchema = z.enum(['notes', 'aiJustification']);
// File: FingerprintsOrderByRelevanceFieldEnum.schema.ts
export const FingerprintsOrderByRelevanceFieldEnumSchema = z.enum(['fingerprint']);
// File: RoleType.schema.ts
export const RoleTypeSchema = z.enum(['assessment', 'course', 'institute', 'verity']);
// File: Permission.schema.ts
export const PermissionSchema = z.enum(['read', 'write', 'deny']);
// File: VerityAssessmentType.schema.ts
export const VerityAssessmentTypeSchema = z.enum(['quiz', 'assignment']);
// File: ScoringStrategy.schema.ts
export const ScoringStrategySchema = z.enum(['highest', 'first', 'latest']);
// File: InstitutionType.schema.ts
export const InstitutionTypeSchema = z.enum(['candidate', 'verity']);
// File: AccountType.schema.ts
export const AccountTypeSchema = z.enum(['production', 'test', 'trial', 'demo']);
// File: InstitutePendingDeletionStatus.schema.ts
export const InstitutePendingDeletionStatusSchema = z.enum(['pendingFinanceApproval', 'pendingArchitectApproval', 'pendingDeletion', 'deleted']);
// File: RecordingMode.schema.ts
export const RecordingModeSchema = z.enum(['off', 'normal', 'strict']);
// File: DisableClipboardMode.schema.ts
export const DisableClipboardModeSchema = z.enum(['off', 'tab', 'system']);
// File: CalculatorMode.schema.ts
export const CalculatorModeSchema = z.enum(['off', 'scientific', 'standard']);
// File: ReferenceMaterialMode.schema.ts
export const ReferenceMaterialModeSchema = z.enum(['off', 'instructor', 'student']);
// File: ProctoringOptionProfileType.schema.ts
export const ProctoringOptionProfileTypeSchema = z.enum(['institute', 'course', 'user', 'assessment', 'preset', 'subAccount']);
// File: DisableProctorMode.schema.ts
export const DisableProctorModeSchema = z.enum(['off', 'extension', 'lockdown', 'mobile']);
// File: CleanupFrequency.schema.ts
export const CleanupFrequencySchema = z.enum(['daily', 'weekly', 'monthly']);
// File: UsageMode.schema.ts
export const UsageModeSchema = z.enum(['unlimited', 'limited', 'metered']);
// File: UsageCategory.schema.ts
export const UsageCategorySchema = z.enum(['automated', 'live', 'popIn', 'popInPostReview']);
// File: UsageType.schema.ts
export const UsageTypeSchema = z.enum(['sessions', 'hours', 'user']);
// File: ProctoringSessionScreencaptureAvailability.schema.ts
export const ProctoringSessionScreencaptureAvailabilitySchema = z.enum(['unavailable', 'processing', 'available', 'error']);
// File: ProctoringSessionWebcamAvailability.schema.ts
export const ProctoringSessionWebcamAvailabilitySchema = z.enum(['unavailable', 'processing', 'available', 'error']);
// File: SignatureType.schema.ts
export const SignatureTypeSchema = z.enum(['photo', 'drawn']);
// File: DemoResultStatus.schema.ts
export const DemoResultStatusSchema = z.enum(['pending', 'processing', 'ready', 'upload_incomplete']);
// File: DemoResultEmailStatus.schema.ts
export const DemoResultEmailStatusSchema = z.enum(['pending', 'queued', 'sending', 'sent', 'failed']);
// File: ProctoringSessionEventStorage.schema.ts
export const ProctoringSessionEventStorageSchema = z.enum(['S3']);
// File: InstallationPlatform.schema.ts
export const InstallationPlatformSchema = z.enum(['extension', 'lockdown', 'mobile']);
// File: AuditLogPlatform.schema.ts
export const AuditLogPlatformSchema = z.enum(['extension', 'lockdown', 'mobile', 'web', 'plugin']);
// File: LiveSessionStatus.schema.ts
export const LiveSessionStatusSchema = z.enum(['pending', 'scheduled', 'creating', 'created', 'destroying', 'destroyed', 'error']);
// File: ScopeSettingsType.schema.ts
export const ScopeSettingsTypeSchema = z.enum(['allCourses', 'selectedAccounts', 'selectedCourses']);
// File: ProctoringSetupUiVersion.schema.ts
export const ProctoringSetupUiVersionSchema = z.enum(['v1', 'v2']);
// File: Language.schema.ts
export const LanguageSchema = z.enum(['en', 'fr']);
// File: ProctoringSessionType.schema.ts
export const ProctoringSessionTypeSchema = z.enum(['automated', 'live', 'popIn']);
// File: ScratchNoteMimeType.schema.ts
export const ScratchNoteMimeTypeSchema = z.enum(['jpeg', 'png', 'jpg']);
// File: ApiVersion.schema.ts
export const ApiVersionSchema = z.enum(['v1', 'v2']);
// File: RecordingType.schema.ts
export const RecordingTypeSchema = z.enum(['webcam', 'screencapture', 'merged', 'roomscan']);
// File: ConcatenationRequestStatus.schema.ts
export const ConcatenationRequestStatusSchema = z.enum(['POSTPROCESS_STARTED', 'POSTPROCESS_COMPLETE', 'POSTPROCESS_FAILED']);
// File: RuleScope.schema.ts
export const RuleScopeSchema = z.enum(['global', 'lmsProvidedCourseId', 'courseNamePrefix']);
// File: RuleType.schema.ts
export const RuleTypeSchema = z.enum(['editConfiguration']);
// File: PaymentType.schema.ts
export const PaymentTypeSchema = z.enum(['assessment', 'attempt']);
// File: RestrictedDeviceRole.schema.ts
export const RestrictedDeviceRoleSchema = z.enum(['source', 'sink']);
// File: RestrictedDevicePlatform.schema.ts
export const RestrictedDevicePlatformSchema = z.enum(['extension', 'mobile', 'lockdown', 'browser']);
// File: SatisfactionLevel.schema.ts
export const SatisfactionLevelSchema = z.enum(['excellent', 'good', 'poor', 'satisfied']);
// File: FeedbackCategory.schema.ts
export const FeedbackCategorySchema = z.enum(['bug', 'comment', 'other', 'suggestion']);
// File: FeedbackStatus.schema.ts
export const FeedbackStatusSchema = z.enum(['completed', 'inProgress', 'notStarted']);
// File: ProctoringSessionSummarySource.schema.ts
export const ProctoringSessionSummarySourceSchema = z.enum(['ai', 'liveProctor']);
// File: VideoPlatform.schema.ts
export const VideoPlatformSchema = z.enum(['zoom', 'teams', 'googleMeet', 'other']);
// File: QuestionType.schema.ts
export const QuestionTypeSchema = z.enum(['MultipleChoice', 'TrueFalse', 'FillInTheBlank', 'Matching', 'FileUpload', 'Essay', 'Ordering', 'AudioRecording', 'FileSubmission', 'DragAndDrop', 'Dropdown', 'Spreadsheet', 'Coding']);
// File: GlobalSetting.schema.ts
export const GlobalSettingSchema = z.object({
    key: z.string(),
    value: z.unknown().refine((val) => { const getDepth = (obj, depth = 0) => { if (depth > 10)
        return depth; if (obj === null || typeof obj !== 'object')
        return depth; const values = Object.values(obj); if (values.length === 0)
        return depth; return Math.max(...values.map(v => getDepth(v, depth + 1))); }; return getDepth(val) <= 10; }, "JSON nesting depth exceeds maximum of 10"),
});
// File: Resource.schema.ts
export const ResourceSchema = z.object({
    id: z.number().int(),
    name: z.string(),
    createdAt: z.date(),
    updatedAt: z.date(),
});
// File: Role.schema.ts
export const RoleSchema = z.object({
    id: z.number().int(),
    name: z.string(),
    type: RoleTypeSchema,
    createdAt: z.date(),
    updatedAt: z.date(),
});
// File: RoleResourcePermission.schema.ts
export const RoleResourcePermissionSchema = z.object({
    id: z.number().int(),
    roleId: z.number().int(),
    resourceId: z.number().int(),
    permission: PermissionSchema,
    createdAt: z.date(),
    updatedAt: z.date(),
});
// File: InstituteUserRole.schema.ts
export const InstituteUserRoleSchema = z.object({
    id: z.number().int(),
    instituteUserId: z.number().int(),
    roleId: z.number().int(),
    createdAt: z.date(),
    updatedAt: z.date(),
});
// File: CourseUserRole.schema.ts
export const CourseUserRoleSchema = z.object({
    id: z.number().int(),
    courseUserId: z.number().int(),
    roleId: z.number().int(),
    createdAt: z.date(),
    updatedAt: z.date(),
});
// File: LmsCourse.schema.ts
export const LmsCourseSchema = z.object({
    id: z.number().int(),
    instituteId: z.number().int(),
    courseId: z.string(),
    courseInfo: z.unknown().refine((val) => { const getDepth = (obj, depth = 0) => { if (depth > 10)
        return depth; if (obj === null || typeof obj !== 'object')
        return depth; const values = Object.values(obj); if (values.length === 0)
        return depth; return Math.max(...values.map(v => getDepth(v, depth + 1))); }; return getDepth(val) <= 10; }, "JSON nesting depth exceeds maximum of 10").nullish(),
    accessControlUuid: z.string().nullish(),
    createdAt: z.date(),
    updatedAt: z.date(),
    verityEnabled: z.boolean().default(true),
    subAccountId: z.number().int().nullish(),
});
// File: LmsCourseUser.schema.ts
export const LmsCourseUserSchema = z.object({
    id: z.number().int(),
    userId: z.number().int(),
    courseId: z.number().int(),
    viewVideos: z.boolean(),
    createdAt: z.date(),
    updatedAt: z.date(),
});
// File: LmsQuiz.schema.ts
export const LmsQuizSchema = z.object({
    id: z.number().int(),
    courseId: z.number().int(),
    quizId: z.string(),
    quizInfo: z.unknown().refine((val) => { const getDepth = (obj, depth = 0) => { if (depth > 10)
        return depth; if (obj === null || typeof obj !== 'object')
        return depth; const values = Object.values(obj); if (values.length === 0)
        return depth; return Math.max(...values.map(v => getDepth(v, depth + 1))); }; return getDepth(val) <= 10; }, "JSON nesting depth exceeds maximum of 10").nullish(),
    other: z.unknown().refine((val) => { const getDepth = (obj, depth = 0) => { if (depth > 10)
        return depth; if (obj === null || typeof obj !== 'object')
        return depth; const values = Object.values(obj); if (values.length === 0)
        return depth; return Math.max(...values.map(v => getDepth(v, depth + 1))); }; return getDepth(val) <= 10; }, "JSON nesting depth exceeds maximum of 10").nullish(),
    isDeleted: z.boolean(),
    summary: z.unknown().refine((val) => { const getDepth = (obj, depth = 0) => { if (depth > 10)
        return depth; if (obj === null || typeof obj !== 'object')
        return depth; const values = Object.values(obj); if (values.length === 0)
        return depth; return Math.max(...values.map(v => getDepth(v, depth + 1))); }; return getDepth(val) <= 10; }, "JSON nesting depth exceeds maximum of 10").nullish(),
    createdAt: z.date(),
    updatedAt: z.date(),
    sourcesLastScanned: z.date().nullish(),
    ltiPayload: z.unknown().refine((val) => { const getDepth = (obj, depth = 0) => { if (depth > 10)
        return depth; if (obj === null || typeof obj !== 'object')
        return depth; const values = Object.values(obj); if (values.length === 0)
        return depth; return Math.max(...values.map(v => getDepth(v, depth + 1))); }; return getDepth(val) <= 10; }, "JSON nesting depth exceeds maximum of 10").nullish(),
});
// File: VerityAssessment.schema.ts
export const VerityAssessmentSchema = z.object({
    quizId: z.number().int(),
    type: VerityAssessmentTypeSchema,
    isPublished: z.boolean(),
    syncGradebook: z.boolean().nullish(),
    startTime: z.date(),
    endTime: z.date(),
    allowLateSubmission: z.boolean(),
    lateSubmissionDate: z.date().nullish(),
    shuffleQuestions: z.boolean().nullish(),
    questionsPerPage: z.number().int().nullish(),
    numAttempts: z.number().int().default(1),
    showScoreOnSubmit: z.boolean().nullish(),
    duration: z.number().int().nullish(),
    description: z.string().nullish(),
    moduleId: z.string().nullish(),
    scoringStrategy: ScoringStrategySchema.default("first"),
    createdAt: z.date(),
    updatedAt: z.date(),
});
// File: AssessmentQuestion.schema.ts
export const AssessmentQuestionSchema = z.object({
    id: z.number().int(),
    assessmentId: z.number().int(),
    lmsProvidedQuestionId: z.string().nullish(),
    title: z.string().nullish(),
    bodyHtml: z.string().nullish(),
    bodyText: z.string().nullish(),
    sources: z.unknown().refine((val) => { const getDepth = (obj, depth = 0) => { if (depth > 10)
        return depth; if (obj === null || typeof obj !== 'object')
        return depth; const values = Object.values(obj); if (values.length === 0)
        return depth; return Math.max(...values.map(v => getDepth(v, depth + 1))); }; return getDepth(val) <= 10; }, "JSON nesting depth exceeds maximum of 10").nullish(),
    numSources: z.number().int(),
    decoySiteHostname: z.string().nullish(),
    decoySitePostId: z.string().nullish(),
    isDeleted: z.boolean(),
    createdAt: z.date(),
    updatedAt: z.date(),
});
// File: QuestionSources.schema.ts
export const QuestionSourcesSchema = z.object({
    id: z.number().int(),
    hostname: z.string(),
    email: z.string().nullish(),
    createdAt: z.date(),
    updatedAt: z.date(),
});
// File: LmsQuizCache.schema.ts
export const LmsQuizCacheSchema = z.object({
    id: z.number().int(),
    quizId: z.string(),
    courseId: z.number().int(),
    platformId: z.number().int().nullish(),
    activityUrl: z.string().nullish(),
    createdAt: z.date(),
    updatedAt: z.date(),
});
// File: LmsQuizCopyChecked.schema.ts
export const LmsQuizCopyCheckedSchema = z.object({
    id: z.number().int(),
    instituteId: z.number().int(),
    lmsCourseId: z.string(),
    quizId: z.string(),
    createdAt: z.date(),
});
// File: Lti1p3Institute.schema.ts
export const Lti1p3InstituteSchema = z.object({
    id: z.number().int(),
    instituteName: z.string().nullish(),
    lms: z.string().nullish(),
    language: z.string().nullish(),
    origin: z.string().nullish(),
    issId: z.number().int().nullish(),
    ltiClientId: z.string().nullish(),
    lmsApiClientId: z.string().nullish(),
    lmsApiClientSecret: z.string().nullish(),
    lmsApiIncludeD2LCorePermission: z.boolean().default(true),
    deploymentId: z.string().nullish(),
    accessControlUuid: z.string().nullish(),
    isDisabled: z.boolean(),
    createdAt: z.date(),
    updatedAt: z.date(),
    institutionType: InstitutionTypeSchema.default("verity"),
    accountType: AccountTypeSchema.default("production"),
});
// File: InstitutePendingDeletion.schema.ts
export const InstitutePendingDeletionSchema = z.object({
    id: z.number().int(),
    instituteId: z.number().int(),
    initiatingUserId: z.string(),
    initiatingUserName: z.string(),
    initiatingUserEmail: z.string(),
    deletionDate: z.date().nullish(),
    status: InstitutePendingDeletionStatusSchema.default("pendingFinanceApproval"),
    createdAt: z.date(),
    updatedAt: z.date(),
});
// File: LuminaPartnerKey.schema.ts
export const LuminaPartnerKeySchema = z.object({
    id: z.number().int(),
    keyId: z.string(),
    keyHash: z.string(),
    label: z.string(),
    createdAt: z.date(),
    lastUsedAt: z.date().nullish(),
    revokedAt: z.date().nullish(),
});
// File: LuminaResultsToken.schema.ts
export const LuminaResultsTokenSchema = z.object({
    id: z.number().int(),
    tokenId: z.string(),
    instituteId: z.number().int(),
    courseId: z.number().int(),
    lmsQuizId: z.number().int(),
    studentId: z.number().int(),
    createdAt: z.date(),
    expiresAt: z.date(),
    redeemedAt: z.date().nullish(),
});
// File: LtiDeploymentHostname.schema.ts
export const LtiDeploymentHostnameSchema = z.object({
    id: z.number().int(),
    ltiDeploymentId: z.number().int(),
    hostname: z.string(),
    createdAt: z.date(),
    updatedAt: z.date(),
});
// File: Lti1p3Iss.schema.ts
export const Lti1p3IssSchema = z.object({
    id: z.number().int(),
    iss: z.string(),
    platformOidcEndpoint: z.string(),
    platformJwksEndpoint: z.string(),
    createdAt: z.date(),
    updatedAt: z.date(),
});
// File: ProctoringExemption.schema.ts
export const ProctoringExemptionSchema = z.object({
    id: z.number().int(),
    assessmentId: z.number().int(),
    userId: z.number().int(),
    proctoringOptionProfileId: z.number().int().nullish(),
    accommodationNotes: z.string().nullish(),
    createdAt: z.date(),
    updatedAt: z.date(),
});
// File: InstitutionProctoringAccommodation.schema.ts
export const InstitutionProctoringAccommodationSchema = z.object({
    id: z.number().int(),
    userId: z.number().int(),
    proctoringOptionProfileId: z.number().int().nullish(),
    accommodationNotes: z.string().nullish(),
    createdAt: z.date(),
    updatedAt: z.date(),
});
// File: LmsToken.schema.ts
export const LmsTokenSchema = z.object({
    id: z.number().int(),
    instituteUserId: z.number().int(),
    accessToken: z.string(),
    refreshToken: z.string(),
    exp: z.number().int(),
    createdAt: z.date(),
    updatedAt: z.date(),
    isDeleted: z.boolean(),
});
// File: ProctoringOption.schema.ts
export const ProctoringOptionSchema = z.object({
    id: z.number().int(),
    videoRecordingMode: RecordingModeSchema.default("off"),
    secondaryVideoRecordingMode: RecordingModeSchema.default("off"),
    audioRecordingMode: RecordingModeSchema.default("off"),
    recordScreen: z.boolean().default(true),
    scanRoom: z.boolean(),
    recordWebTraffic: z.boolean(),
    detectSidePanel: z.boolean(),
    oneScreenEnforcementMode: RecordingModeSchema.default("off"),
    disableNewTab: z.boolean(),
    closeOpenTabs: z.boolean(),
    tabWhiteList: z.unknown().refine((val) => { const getDepth = (obj, depth = 0) => { if (depth > 10)
        return depth; if (obj === null || typeof obj !== 'object')
        return depth; const values = Object.values(obj); if (values.length === 0)
        return depth; return Math.max(...values.map(v => getDepth(v, depth + 1))); }; return getDepth(val) <= 10; }, "JSON nesting depth exceeds maximum of 10").nullish(),
    disableClipboardMode: DisableClipboardModeSchema.default("off"),
    enableGuidedAccessMode: z.boolean(),
    restrictHandoffMode: RecordingModeSchema.default("off"),
    showRecordingPanel: z.boolean().default(true),
    idVerification: z.boolean(),
    idVerificationEnableAi: z.boolean(),
    faceTrackingMode: RecordingModeSchema.default("off"),
    objectDetectionMode: RecordingModeSchema.default("off"),
    enforceLockdown: z.boolean(),
    enforceMobile: z.boolean(),
    isExtension: z.boolean(),
    isLockdown: z.boolean(),
    isMobile: z.boolean(),
    isChromeOs: z.boolean(),
    isBrowser: z.boolean(),
    recordClipboard: z.boolean(),
    recordInput: z.boolean(),
    excludedWebTrafficRecordingUrls: z.unknown().refine((val) => { const getDepth = (obj, depth = 0) => { if (depth > 10)
        return depth; if (obj === null || typeof obj !== 'object')
        return depth; const values = Object.values(obj); if (values.length === 0)
        return depth; return Math.max(...values.map(v => getDepth(v, depth + 1))); }; return getDepth(val) <= 10; }, "JSON nesting depth exceeds maximum of 10").nullish(),
    disableSpellcheck: z.boolean(),
    disablePrinting: z.boolean(),
    disableRightClick: z.boolean(),
    extensionBlockMode: RecordingModeSchema.default("off"),
    allowedExtensionsList: z.unknown().refine((val) => { const getDepth = (obj, depth = 0) => { if (depth > 10)
        return depth; if (obj === null || typeof obj !== 'object')
        return depth; const values = Object.values(obj); if (values.length === 0)
        return depth; return Math.max(...values.map(v => getDepth(v, depth + 1))); }; return getDepth(val) <= 10; }, "JSON nesting depth exceeds maximum of 10").nullish(),
    logInstalledExtensions: z.boolean(),
    tabBlockList: z.unknown().refine((val) => { const getDepth = (obj, depth = 0) => { if (depth > 10)
        return depth; if (obj === null || typeof obj !== 'object')
        return depth; const values = Object.values(obj); if (values.length === 0)
        return depth; return Math.max(...values.map(v => getDepth(v, depth + 1))); }; return getDepth(val) <= 10; }, "JSON nesting depth exceeds maximum of 10").nullish(),
    hideOtherWindows: z.boolean().default(true),
    keyboardShortcutBlockList: z.unknown().refine((val) => { const getDepth = (obj, depth = 0) => { if (depth > 10)
        return depth; if (obj === null || typeof obj !== 'object')
        return depth; const values = Object.values(obj); if (values.length === 0)
        return depth; return Math.max(...values.map(v => getDepth(v, depth + 1))); }; return getDepth(val) <= 10; }, "JSON nesting depth exceeds maximum of 10").nullish(),
    disableDownloadFiles: z.boolean(),
    applicationBlockMode: RecordingModeSchema.default("off"),
    blockWindowedApplications: z.boolean(),
    applicationBlockList: z.unknown().refine((val) => { const getDepth = (obj, depth = 0) => { if (depth > 10)
        return depth; if (obj === null || typeof obj !== 'object')
        return depth; const values = Object.values(obj); if (values.length === 0)
        return depth; return Math.max(...values.map(v => getDepth(v, depth + 1))); }; return getDepth(val) <= 10; }, "JSON nesting depth exceeds maximum of 10").nullish(),
    allowedApplicationsList: z.unknown().refine((val) => { const getDepth = (obj, depth = 0) => { if (depth > 10)
        return depth; if (obj === null || typeof obj !== 'object')
        return depth; const values = Object.values(obj); if (values.length === 0)
        return depth; return Math.max(...values.map(v => getDepth(v, depth + 1))); }; return getDepth(val) <= 10; }, "JSON nesting depth exceeds maximum of 10").nullish(),
    blockVirtualMachines: z.boolean(),
    recordApplicationsActivity: z.boolean(),
    logRunningApplications: z.boolean(),
    quietEnvironment: z.boolean(),
    enableCalculator: CalculatorModeSchema.default("off"),
    enableWhiteboard: z.boolean(),
    enableCodeEditor: z.boolean(),
    codeEditorRoomId: z.unknown().refine((val) => { const getDepth = (obj, depth = 0) => { if (depth > 10)
        return depth; if (obj === null || typeof obj !== 'object')
        return depth; const values = Object.values(obj); if (values.length === 0)
        return depth; return Math.max(...values.map(v => getDepth(v, depth + 1))); }; return getDepth(val) <= 10; }, "JSON nesting depth exceeds maximum of 10").nullish(),
    uploadScratchNotes: z.boolean(),
    idVerificationMode: RecordingModeSchema.default("off"),
    restrictDevices: z.boolean(),
    enableManualEndProctoring: z.boolean(),
    enableReferenceMaterial: z.boolean(),
    referenceMaterialMode: ReferenceMaterialModeSchema.default("off"),
    audioTranscription: z.boolean(),
    flaggedKeywords: z.unknown().refine((val) => { const getDepth = (obj, depth = 0) => { if (depth > 10)
        return depth; if (obj === null || typeof obj !== 'object')
        return depth; const values = Object.values(obj); if (values.length === 0)
        return depth; return Math.max(...values.map(v => getDepth(v, depth + 1))); }; return getDepth(val) <= 10; }, "JSON nesting depth exceeds maximum of 10").default("null"),
    uploadSignature: z.boolean(),
    enableGeofence: z.boolean(),
    geofenceLocations: z.unknown().refine((val) => { const getDepth = (obj, depth = 0) => { if (depth > 10)
        return depth; if (obj === null || typeof obj !== 'object')
        return depth; const values = Object.values(obj); if (values.length === 0)
        return depth; return Math.max(...values.map(v => getDepth(v, depth + 1))); }; return getDepth(val) <= 10; }, "JSON nesting depth exceeds maximum of 10").nullish(),
    disableVirtualCamera: z.boolean(),
    enableIpAddressRestriction: z.boolean(),
    allowedIpAddresses: z.unknown().refine((val) => { const getDepth = (obj, depth = 0) => { if (depth > 10)
        return depth; if (obj === null || typeof obj !== 'object')
        return depth; const values = Object.values(obj); if (values.length === 0)
        return depth; return Math.max(...values.map(v => getDepth(v, depth + 1))); }; return getDepth(val) <= 10; }, "JSON nesting depth exceeds maximum of 10").nullish(),
    createdAt: z.date(),
    updatedAt: z.date(),
});
// File: ThirdPartyAssessmentOption.schema.ts
export const ThirdPartyAssessmentOptionSchema = z.object({
    id: z.number().int(),
    thirdPartyUrl: z.string().nullish(),
    password: z.string().nullish(),
    proctoringAssessmentConfigurationId: z.number().int(),
    thirdPartyPlatformId: z.number().int().nullish(),
    createdAt: z.date(),
    updatedAt: z.date(),
});
// File: ProctoringAssessmentConfiguration.schema.ts
export const ProctoringAssessmentConfigurationSchema = z.object({
    id: z.number().int(),
    lmsQuizId: z.number().int(),
    proctoringOptionProfileId: z.number().int(),
    enabled: z.boolean(),
    isLiveProctored: z.boolean(),
    isLivePopIn: z.boolean(),
    enablePostReview: z.boolean(),
    forceChromeOsManagedGuestSession: z.boolean(),
    password: z.string().nullish(),
    createdAt: z.date(),
    updatedAt: z.date(),
});
// File: ProctoringOptionProfile.schema.ts
export const ProctoringOptionProfileSchema = z.object({
    id: z.number().int(),
    name: z.string().nullish(),
    proctoringOptionId: z.number().int(),
    type: ProctoringOptionProfileTypeSchema,
    createdAt: z.date(),
    updatedAt: z.date(),
});
// File: ProctoringOptionInstituteProfile.schema.ts
export const ProctoringOptionInstituteProfileSchema = z.object({
    id: z.number().int(),
    enforced: z.boolean(),
    instituteId: z.number().int(),
    proctoringOptionProfileId: z.number().int(),
});
// File: ProctoringOptionCourseProfile.schema.ts
export const ProctoringOptionCourseProfileSchema = z.object({
    id: z.number().int(),
    courseId: z.number().int(),
    proctoringOptionProfileId: z.number().int(),
});
// File: ProctoringOptionUserProfile.schema.ts
export const ProctoringOptionUserProfileSchema = z.object({
    id: z.number().int(),
    userId: z.number().int(),
    proctoringOptionProfileId: z.number().int(),
});
// File: ProctoringOptionSubAccountProfile.schema.ts
export const ProctoringOptionSubAccountProfileSchema = z.object({
    id: z.number().int(),
    proctoringOptionProfileId: z.number().int(),
    subAccountId: z.number().int(),
});
// File: VerityInstituteSettings.schema.ts
export const VerityInstituteSettingsSchema = z.object({
    id: z.number().int(),
    instituteId: z.number().int(),
    allowLiveProctoring: z.boolean(),
    liveProctoringResetableCredits: z.number().int().nullish(),
    liveProctoringCreditsResetDate: z.date().nullish(),
    liveProctoringOneTimeCredits: z.number(),
    allowLivePopIn: z.boolean(),
    livePopInResetableCredits: z.number().int().nullish(),
    livePopInCreditsResetDate: z.date().nullish(),
    livePopInOneTimeCredits: z.number(),
    allowLivePopInPostReview: z.boolean(),
    allowAutomatedProctoring: z.boolean().default(true),
    allowStandaloneMode: z.boolean(),
    disableProctorMode: DisableProctorModeSchema.default("off"),
    allowDemoMode: z.boolean(),
    allowAiStrictMode: z.boolean(),
    allowExtensionPlatform: z.boolean().default(true),
    allowLockdownPlatform: z.boolean().default(true),
    allowMobilePlatform: z.boolean(),
    allowBrowserPlatform: z.boolean(),
    showAllAssessments: z.boolean().default(true),
    liteMode: z.boolean(),
    liteModeViewReports: z.boolean(),
    salesforceId: z.string().nullish(),
    cleanupEnabled: z.boolean(),
    cutoffDate: z.date().nullish(),
    cleanupFrequency: CleanupFrequencySchema.nullish(),
    lastCleanupAt: z.date().nullish(),
    allowVerityAssessment: z.boolean().default(true),
    tier: z.number().int().default(1),
    disabledProctoringOptions: z.unknown().refine((val) => { const getDepth = (obj, depth = 0) => { if (depth > 10)
        return depth; if (obj === null || typeof obj !== 'object')
        return depth; const values = Object.values(obj); if (values.length === 0)
        return depth; return Math.max(...values.map(v => getDepth(v, depth + 1))); }; return getDepth(val) <= 10; }, "JSON nesting depth exceeds maximum of 10").nullish(),
    createdAt: z.date(),
    updatedAt: z.date(),
});
// File: InstituteUsageLimit.schema.ts
export const InstituteUsageLimitSchema = z.object({
    id: z.number().int(),
    instituteId: z.number().int(),
    usageMode: UsageModeSchema.default("unlimited"),
    category: UsageCategorySchema,
    proctorGroupId: z.string(),
    type: UsageTypeSchema,
    resetableLimit: z.number().int(),
    resetDate: z.date(),
    oneTimeCredits: z.number(),
    annualType: UsageTypeSchema,
    oneTimeCreditsType: UsageTypeSchema,
});
// File: InstituteUsageCache.schema.ts
export const InstituteUsageCacheSchema = z.object({
    id: z.number().int(),
    instituteId: z.number().int(),
    category: UsageCategorySchema,
    proctorGroupId: z.string(),
    type: UsageTypeSchema,
    date: z.date(),
    usage: z.number(),
});
// File: InstituteUsageUserCache.schema.ts
export const InstituteUsageUserCacheSchema = z.object({
    id: z.number().int(),
    instituteId: z.number().int(),
    category: UsageCategorySchema,
    proctorGroupId: z.string(),
    date: z.date(),
    studentId: z.number().int(),
});
// File: LiveSessionUsageCache.schema.ts
export const LiveSessionUsageCacheSchema = z.object({
    id: z.string(),
    instituteId: z.number().int(),
    proctorGroupIds: z.unknown().refine((val) => { const getDepth = (obj, depth = 0) => { if (depth > 10)
        return depth; if (obj === null || typeof obj !== 'object')
        return depth; const values = Object.values(obj); if (values.length === 0)
        return depth; return Math.max(...values.map(v => getDepth(v, depth + 1))); }; return getDepth(val) <= 10; }, "JSON nesting depth exceeds maximum of 10").default("[]"),
    startTime: z.date(),
    endTime: z.date(),
    hours: z.number(),
    sessions: z.number(),
    user: z.number(),
});
// File: ProctoringSession.schema.ts
export const ProctoringSessionSchema = z.object({
    id: z.number().int(),
    uuid: z.string(),
    createdAt: z.date(),
    updatedAt: z.date(),
    lmsQuizId: z.number().int(),
    studentId: z.number().int(),
    screencaptureAvailability: ProctoringSessionScreencaptureAvailabilitySchema.default("unavailable"),
    webcamAvailability: ProctoringSessionWebcamAvailabilitySchema.default("unavailable"),
    screencaptureVideos: z.unknown().refine((val) => { const getDepth = (obj, depth = 0) => { if (depth > 10)
        return depth; if (obj === null || typeof obj !== 'object')
        return depth; const values = Object.values(obj); if (values.length === 0)
        return depth; return Math.max(...values.map(v => getDepth(v, depth + 1))); }; return getDepth(val) <= 10; }, "JSON nesting depth exceeds maximum of 10").nullish(),
    webcamVideos: z.unknown().refine((val) => { const getDepth = (obj, depth = 0) => { if (depth > 10)
        return depth; if (obj === null || typeof obj !== 'object')
        return depth; const values = Object.values(obj); if (values.length === 0)
        return depth; return Math.max(...values.map(v => getDepth(v, depth + 1))); }; return getDepth(val) <= 10; }, "JSON nesting depth exceeds maximum of 10").nullish(),
    idPhotoAvailable: z.boolean(),
    personPhotoAvailable: z.boolean(),
    liveSessionId: z.string().nullish(),
    liveUserSessionId: z.string().nullish(),
    postReviewPending: z.boolean(),
    liveProctorSummaryPending: z.boolean(),
    usageTracked: z.boolean(),
    ipAddress: z.string().nullish(),
    isWebcamAndScreenCaptureDeleted: z.boolean(),
    webcamAndScreenCaptureDeleteCause: z.string().nullish(),
    webcamAndScreenCaptureDeleteAt: z.date().nullish(),
    isRoomScanDeleted: z.boolean(),
    roomScanDeleteCause: z.string().nullish(),
    roomScanDeleteAt: z.date().nullish(),
    syncedToLmsAt: z.date().nullish(),
    signatureType: SignatureTypeSchema.nullish(),
});
// File: DemoSession.schema.ts
export const DemoSessionSchema = z.object({
    id: z.string(),
    email: z.string(),
    firstName: z.string(),
    lastName: z.string(),
    organization: z.string(),
    role: z.string(),
    verificationTokenHash: z.string(),
    verificationExpiresAt: z.date(),
    verifiedAt: z.date().nullish(),
    demoSessionTokenHash: z.string().nullish(),
    demoUserId: z.number().int().nullish(),
    accessControlAccountId: z.string().nullish(),
    principalExpiresAt: z.date().nullish(),
    proctoringSessionUuid: z.string().nullish(),
    completedAt: z.date().nullish(),
    resultStatus: DemoResultStatusSchema.default("pending"),
    processingStartedAt: z.date().nullish(),
    processingDeadlineAt: z.date().nullish(),
    resultReadyAt: z.date().nullish(),
    resultTokenHash: z.string().nullish(),
    resultEmailTokenCiphertext: z.string().nullish(),
    resultExpiresAt: z.date().nullish(),
    resultEmailStatus: DemoResultEmailStatusSchema.default("pending"),
    resultEmailAttempts: z.number().int(),
    resultEmailLastAttemptAt: z.date().nullish(),
    resultEmailNextAttemptAt: z.date().nullish(),
    resultEmailSentAt: z.date().nullish(),
    cameraDisconnectSelfReportedAt: z.date().nullish(),
    createdAt: z.date(),
    updatedAt: z.date(),
});
// File: ProctoringSessionAnomalies.schema.ts
export const ProctoringSessionAnomaliesSchema = z.object({
    id: z.number().int(),
    proctoringSessionId: z.number().int(),
    type: z.string(),
    flagLevel: z.number().int(),
    timeStart: z.date().nullish(),
    timeEnd: z.date().nullish(),
    resolved: z.boolean(),
    comment: z.string().nullish(),
    createdAt: z.date(),
    updatedAt: z.date(),
});
// File: ProctoringSessionEvent.schema.ts
export const ProctoringSessionEventSchema = z.object({
    id: z.number().int(),
    proctoringSessionId: z.number().int(),
    type: z.string(),
    name: z.string(),
    details: z.unknown().refine((val) => { const getDepth = (obj, depth = 0) => { if (depth > 10)
        return depth; if (obj === null || typeof obj !== 'object')
        return depth; const values = Object.values(obj); if (values.length === 0)
        return depth; return Math.max(...values.map(v => getDepth(v, depth + 1))); }; return getDepth(val) <= 10; }, "JSON nesting depth exceeds maximum of 10"),
    time: z.date(),
    endTime: z.date().nullish(),
    createdAt: z.date(),
    updatedAt: z.date(),
    anomalyRef: z.number().int().nullish(),
});
// File: ProctoringSessionRekognitionEvent.schema.ts
export const ProctoringSessionRekognitionEventSchema = z.object({
    id: z.number().int(),
    proctoringSessionId: z.number().int(),
    time: z.date(),
    storage: ProctoringSessionEventStorageSchema,
});
// File: User.schema.ts
export const UserSchema = z.object({
    id: z.number().int(),
    lmsProvidedUserId: z.string(),
    instituteId: z.number().int(),
    editInstitute: z.boolean(),
    name: z.string().nullish(),
    userInfo: z.unknown().refine((val) => { const getDepth = (obj, depth = 0) => { if (depth > 10)
        return depth; if (obj === null || typeof obj !== 'object')
        return depth; const values = Object.values(obj); if (values.length === 0)
        return depth; return Math.max(...values.map(v => getDepth(v, depth + 1))); }; return getDepth(val) <= 10; }, "JSON nesting depth exceeds maximum of 10").nullish(),
    other: z.unknown().refine((val) => { const getDepth = (obj, depth = 0) => { if (depth > 10)
        return depth; if (obj === null || typeof obj !== 'object')
        return depth; const values = Object.values(obj); if (values.length === 0)
        return depth; return Math.max(...values.map(v => getDepth(v, depth + 1))); }; return getDepth(val) <= 10; }, "JSON nesting depth exceeds maximum of 10").nullish(),
    accessControlUuid: z.string().nullish(),
    stripeUserId: z.string().nullish(),
    createdAt: z.date(),
    updatedAt: z.date(),
});
// File: UserSession.schema.ts
export const UserSessionSchema = z.object({
    id: z.number().int(),
    sid: z.string(),
    expires: z.date().nullish(),
    data: z.unknown().refine((val) => { const getDepth = (obj, depth = 0) => { if (depth > 10)
        return depth; if (obj === null || typeof obj !== 'object')
        return depth; const values = Object.values(obj); if (values.length === 0)
        return depth; return Math.max(...values.map(v => getDepth(v, depth + 1))); }; return getDepth(val) <= 10; }, "JSON nesting depth exceeds maximum of 10").nullish(),
    createdAt: z.date(),
    updatedAt: z.date(),
    userId: z.number().int().nullish(),
});
// File: UserSecurityPin.schema.ts
export const UserSecurityPinSchema = z.object({
    userId: z.number().int(),
    pin: z.number().int(),
    createdAt: z.date(),
    updatedAt: z.date(),
});
// File: UserState.schema.ts
export const UserStateSchema = z.object({
    userId: z.number().int(),
    npsSurveyShownAt: z.date().nullish(),
    latestReportShownAt: z.date().nullish(),
    candidateWelcomeShownAt: z.date().nullish(),
    loginCount: z.number().int(),
    activeSetupStep: z.string().nullish(),
    tosAgreedAt: z.date().nullish(),
    createdAt: z.date(),
    updatedAt: z.date(),
});
// File: YujaAccount.schema.ts
export const YujaAccountSchema = z.object({
    id: z.number().int(),
    username: z.string(),
    password: z.string(),
    roleId: z.number().int(),
    createdAt: z.date(),
    updatedAt: z.date(),
});
// File: YujaAccountRole.schema.ts
export const YujaAccountRoleSchema = z.object({
    id: z.number().int(),
    role: z.string(),
    permissions: z.unknown().refine((val) => { const getDepth = (obj, depth = 0) => { if (depth > 10)
        return depth; if (obj === null || typeof obj !== 'object')
        return depth; const values = Object.values(obj); if (values.length === 0)
        return depth; return Math.max(...values.map(v => getDepth(v, depth + 1))); }; return getDepth(val) <= 10; }, "JSON nesting depth exceeds maximum of 10").nullish(),
    createdAt: z.date(),
    updatedAt: z.date(),
});
// File: YujaDebugInstance.schema.ts
export const YujaDebugInstanceSchema = z.object({
    id: z.number().int(),
    uuid: z.string(),
    system: z.unknown().refine((val) => { const getDepth = (obj, depth = 0) => { if (depth > 10)
        return depth; if (obj === null || typeof obj !== 'object')
        return depth; const values = Object.values(obj); if (values.length === 0)
        return depth; return Math.max(...values.map(v => getDepth(v, depth + 1))); }; return getDepth(val) <= 10; }, "JSON nesting depth exceeds maximum of 10"),
    createdAt: z.date(),
    updatedAt: z.date(),
});
// File: YujaDebugStatistic.schema.ts
export const YujaDebugStatisticSchema = z.object({
    id: z.number().int(),
    instanceId: z.number().int(),
    userId: z.number().int().nullish(),
    userSessionId: z.number().int().nullish(),
    proctoringSessionId: z.number().int().nullish(),
    type: z.string(),
    time: z.date(),
    details: z.unknown().refine((val) => { const getDepth = (obj, depth = 0) => { if (depth > 10)
        return depth; if (obj === null || typeof obj !== 'object')
        return depth; const values = Object.values(obj); if (values.length === 0)
        return depth; return Math.max(...values.map(v => getDepth(v, depth + 1))); }; return getDepth(val) <= 10; }, "JSON nesting depth exceeds maximum of 10").nullish(),
    createdAt: z.date(),
    updatedAt: z.date(),
});
// File: Installation.schema.ts
export const InstallationSchema = z.object({
    id: z.string(),
    platform: InstallationPlatformSchema,
    version: z.string(),
    fingerprint: z.string(),
    details: z.unknown().refine((val) => { const getDepth = (obj, depth = 0) => { if (depth > 10)
        return depth; if (obj === null || typeof obj !== 'object')
        return depth; const values = Object.values(obj); if (values.length === 0)
        return depth; return Math.max(...values.map(v => getDepth(v, depth + 1))); }; return getDepth(val) <= 10; }, "JSON nesting depth exceeds maximum of 10"),
    createdAt: z.date(),
    updatedAt: z.date(),
});
// File: AuditLogSession.schema.ts
export const AuditLogSessionSchema = z.object({
    id: z.number().int(),
    installationId: z.string().nullish(),
    userId: z.string().nullish(),
    fingerprint: z.string().nullish(),
    platform: AuditLogPlatformSchema,
    platformDetails: z.unknown().refine((val) => { const getDepth = (obj, depth = 0) => { if (depth > 10)
        return depth; if (obj === null || typeof obj !== 'object')
        return depth; const values = Object.values(obj); if (values.length === 0)
        return depth; return Math.max(...values.map(v => getDepth(v, depth + 1))); }; return getDepth(val) <= 10; }, "JSON nesting depth exceeds maximum of 10").nullish(),
    systemDetails: z.unknown().refine((val) => { const getDepth = (obj, depth = 0) => { if (depth > 10)
        return depth; if (obj === null || typeof obj !== 'object')
        return depth; const values = Object.values(obj); if (values.length === 0)
        return depth; return Math.max(...values.map(v => getDepth(v, depth + 1))); }; return getDepth(val) <= 10; }, "JSON nesting depth exceeds maximum of 10").nullish(),
    createdAt: z.date(),
});
// File: AuditLog.schema.ts
export const AuditLogSchema = z.object({
    id: z.number().int(),
    sessionId: z.number().int(),
    context: z.unknown().refine((val) => { const getDepth = (obj, depth = 0) => { if (depth > 10)
        return depth; if (obj === null || typeof obj !== 'object')
        return depth; const values = Object.values(obj); if (values.length === 0)
        return depth; return Math.max(...values.map(v => getDepth(v, depth + 1))); }; return getDepth(val) <= 10; }, "JSON nesting depth exceeds maximum of 10").nullish(),
    type: z.string(),
    ipAddress: z.string().nullish(),
    proctoringSessionId: z.string().nullish(),
    liveSessionId: z.string().nullish(),
    details: z.unknown().refine((val) => { const getDepth = (obj, depth = 0) => { if (depth > 10)
        return depth; if (obj === null || typeof obj !== 'object')
        return depth; const values = Object.values(obj); if (values.length === 0)
        return depth; return Math.max(...values.map(v => getDepth(v, depth + 1))); }; return getDepth(val) <= 10; }, "JSON nesting depth exceeds maximum of 10").nullish(),
    time: z.date(),
    createdAt: z.date(),
});
// File: LiveSession.schema.ts
export const LiveSessionSchema = z.object({
    id: z.number().int(),
    assessmentId: z.number().int(),
    liveProvidedSessionId: z.string().nullish(),
    status: LiveSessionStatusSchema.default("scheduled"),
    name: z.string(),
    startTime: z.date(),
    endTime: z.date(),
    capacity: z.number().int().default(50),
    demoMode: z.boolean(),
    createdAt: z.date(),
    updatedAt: z.date(),
});
// File: LiveSessionStudent.schema.ts
export const LiveSessionStudentSchema = z.object({
    id: z.number().int(),
    liveSessionId: z.number().int(),
    instituteUserId: z.number().int(),
    joined: z.boolean(),
    createdAt: z.date(),
    updatedAt: z.date(),
});
// File: ProctorGroup.schema.ts
export const ProctorGroupSchema = z.object({
    id: z.number().int(),
    name: z.string(),
    ownerInstituteId: z.number().int(),
    createdAt: z.date(),
    updatedAt: z.date(),
});
// File: ProctorGroupAllowedInstitute.schema.ts
export const ProctorGroupAllowedInstituteSchema = z.object({
    id: z.number().int(),
    proctorGroupId: z.number().int(),
    instituteId: z.number().int(),
    minHoursNotice: z.number().int().default(36),
    hoursNotAcceptedNotify: z.number().int().default(24),
    hoursTrackCancellation: z.number().int(),
    trackCancellationMessage: z.string(),
    createdAt: z.date(),
    updatedAt: z.date(),
});
// File: ProctorGroupProctor.schema.ts
export const ProctorGroupProctorSchema = z.object({
    id: z.number().int(),
    userId: z.string(),
    proctorGroupId: z.number().int(),
    createdAt: z.date(),
    updatedAt: z.date(),
});
// File: ProctorGroupAdmin.schema.ts
export const ProctorGroupAdminSchema = z.object({
    id: z.number().int(),
    userId: z.string(),
    proctorGroupId: z.number().int(),
    createdAt: z.date(),
    updatedAt: z.date(),
});
// File: ProctorAvailability.schema.ts
export const ProctorAvailabilitySchema = z.object({
    id: z.number().int(),
    userId: z.string(),
    availability: z.unknown().refine((val) => { const getDepth = (obj, depth = 0) => { if (depth > 10)
        return depth; if (obj === null || typeof obj !== 'object')
        return depth; const values = Object.values(obj); if (values.length === 0)
        return depth; return Math.max(...values.map(v => getDepth(v, depth + 1))); }; return getDepth(val) <= 10; }, "JSON nesting depth exceeds maximum of 10"),
    createdAt: z.date(),
    updatedAt: z.date(),
});
// File: LiveSessionProctor.schema.ts
export const LiveSessionProctorSchema = z.object({
    id: z.number().int(),
    liveSessionId: z.number().int(),
    instituteUserId: z.number().int(),
    joined: z.boolean(),
    createdAt: z.date(),
    updatedAt: z.date(),
});
// File: LiveSessionProctorGroup.schema.ts
export const LiveSessionProctorGroupSchema = z.object({
    id: z.number().int(),
    liveSessionId: z.number().int(),
    proctorGroupId: z.number().int(),
    selectedProctorId: z.string().nullish(),
    joined: z.boolean(),
    checkProctorAt: z.date().nullish(),
    createdAt: z.date(),
    updatedAt: z.date(),
});
// File: LiveSessionNote.schema.ts
export const LiveSessionNoteSchema = z.object({
    id: z.number().int(),
    liveSessionId: z.number().int(),
    studentInstituteUserId: z.number().int(),
    createdAt: z.date(),
    updatedAt: z.date(),
});
// File: LiveSessionNoteEdit.schema.ts
export const LiveSessionNoteEditSchema = z.object({
    id: z.number().int(),
    liveSessionId: z.number().int(),
    liveSessionNoteId: z.number().int(),
    editorId: z.string(),
    editorInstituteUserId: z.number().int().nullish(),
    content: z.string(),
    createdAt: z.date(),
    updatedAt: z.date(),
});
// File: CancelledLiveSession.schema.ts
export const CancelledLiveSessionSchema = z.object({
    id: z.number().int(),
    liveSessionId: z.number().int(),
    assessmentId: z.number().int(),
    assessmentName: z.string().nullish(),
    courseId: z.number().int(),
    courseName: z.string().nullish(),
    instituteId: z.number().int(),
    instituteName: z.string().nullish(),
    name: z.string(),
    startTime: z.date(),
    endTime: z.date(),
    capacity: z.number().int().default(50),
    sessionCreatedAt: z.date(),
    sessionUpdatedAt: z.date(),
    cancelledAt: z.date(),
    recordUpdatedAt: z.date(),
});
// File: CancelledLiveSessionProctorGroup.schema.ts
export const CancelledLiveSessionProctorGroupSchema = z.object({
    id: z.number().int(),
    cancelledLiveSessionId: z.number().int(),
    proctorGroupId: z.number().int(),
    selectedProctorId: z.string().nullish(),
    createdAt: z.date(),
    updatedAt: z.date(),
});
// File: CourseEmailSettings.schema.ts
export const CourseEmailSettingsSchema = z.object({
    id: z.number().int(),
    instituteUserId: z.number().int(),
    courseId: z.number().int(),
    createdAt: z.date(),
    updatedAt: z.date(),
});
// File: CourseSettings.schema.ts
export const CourseSettingsSchema = z.object({
    id: z.number().int(),
    courseId: z.number().int(),
    allowStopRecording: z.boolean().default(true),
    geofenceLocations: z.unknown().refine((val) => { const getDepth = (obj, depth = 0) => { if (depth > 10)
        return depth; if (obj === null || typeof obj !== 'object')
        return depth; const values = Object.values(obj); if (values.length === 0)
        return depth; return Math.max(...values.map(v => getDepth(v, depth + 1))); }; return getDepth(val) <= 10; }, "JSON nesting depth exceeds maximum of 10").nullish(),
    createdAt: z.date(),
    updatedAt: z.date(),
});
// File: ThirdPartyPlatform.schema.ts
export const ThirdPartyPlatformSchema = z.object({
    id: z.number().int(),
    name: z.string(),
});
// File: InstituteAndThirdPartyPlatforms.schema.ts
export const InstituteAndThirdPartyPlatformsSchema = z.object({
    id: z.number().int(),
    instituteId: z.number().int(),
    platformId: z.number().int(),
});
// File: InstituteSettings.schema.ts
export const InstituteSettingsSchema = z.object({
    id: z.number().int(),
    instituteId: z.number().int(),
    allowStopRecording: z.boolean().default(true),
    policyStatementFileName: z.string().nullish(),
    defaultProctoringOptionProfileId: z.number().int().nullish(),
    disabledProctoringOptions: z.unknown().refine((val) => { const getDepth = (obj, depth = 0) => { if (depth > 10)
        return depth; if (obj === null || typeof obj !== 'object')
        return depth; const values = Object.values(obj); if (values.length === 0)
        return depth; return Math.max(...values.map(v => getDepth(v, depth + 1))); }; return getDepth(val) <= 10; }, "JSON nesting depth exceeds maximum of 10").nullish(),
    allowStrictMode: z.boolean().default(true),
    suffix: z.string().default("YuJa Verity Test Proctoring").nullish(),
    createdAt: z.date(),
    updatedAt: z.date(),
    scopeSettingsMode: ScopeSettingsTypeSchema.default("allCourses"),
    lockdownRequireManagedGuestSession: z.boolean(),
    managedGuestSessionRequireIncognito: z.boolean().default(true),
    delayRecordingUntilAssessmentStart: z.boolean(),
    allowPortalMadeThirdPartyAssessments: z.boolean(),
    flaggedKeywords: z.unknown().refine((val) => { const getDepth = (obj, depth = 0) => { if (depth > 10)
        return depth; if (obj === null || typeof obj !== 'object')
        return depth; const values = Object.values(obj); if (values.length === 0)
        return depth; return Math.max(...values.map(v => getDepth(v, depth + 1))); }; return getDepth(val) <= 10; }, "JSON nesting depth exceeds maximum of 10").default("null"),
    allowQuizAttemptOnChrome: z.boolean().default(true),
    allowQuizAttemptOnFirefox: z.boolean(),
    allowQuizAttemptOnSafari: z.boolean(),
    recordingMaxAgeMonths: z.number().int().default(12),
    sessionRecordingLimitHours: z.number().int().default(12).nullish(),
    proctoringRegistrationNotifications: z.boolean().default(true),
    preferredProctoringSetupUiVersion: ProctoringSetupUiVersionSchema.default("v2"),
    dailyDigestEmailEnabled: z.boolean().default(true),
    platformChatEnabled: z.boolean(),
});
// File: UserSettings.schema.ts
export const UserSettingsSchema = z.object({
    id: z.number().int(),
    instituteUserId: z.number().int(),
    language: LanguageSchema.nullish(),
    createdAt: z.date(),
    updatedAt: z.date(),
});
// File: TemporaryAccessCode.schema.ts
export const TemporaryAccessCodeSchema = z.object({
    accessCode: z.string(),
    userId: z.number().int(),
    data: z.unknown().refine((val) => { const getDepth = (obj, depth = 0) => { if (depth > 10)
        return depth; if (obj === null || typeof obj !== 'object')
        return depth; const values = Object.values(obj); if (values.length === 0)
        return depth; return Math.max(...values.map(v => getDepth(v, depth + 1))); }; return getDepth(val) <= 10; }, "JSON nesting depth exceeds maximum of 10").nullish(),
    createdAt: z.date(),
});
// File: StandaloneStudentInfo.schema.ts
export const StandaloneStudentInfoSchema = z.object({
    id: z.number().int(),
    userId: z.number().int(),
    accessCode: z.string(),
    email: z.string(),
    firstName: z.string(),
    lastName: z.string(),
    data: z.unknown().refine((val) => { const getDepth = (obj, depth = 0) => { if (depth > 10)
        return depth; if (obj === null || typeof obj !== 'object')
        return depth; const values = Object.values(obj); if (values.length === 0)
        return depth; return Math.max(...values.map(v => getDepth(v, depth + 1))); }; return getDepth(val) <= 10; }, "JSON nesting depth exceeds maximum of 10").nullish(),
    createdAt: z.date(),
    expiryDate: z.date(),
    lmsQuizId: z.number().int(),
    accountId: z.string().nullish(),
});
// File: LmsCourseAnomalyConfig.schema.ts
export const LmsCourseAnomalyConfigSchema = z.object({
    id: z.number().int(),
    lmsCourseId: z.number().int(),
    setting: z.unknown().refine((val) => { const getDepth = (obj, depth = 0) => { if (depth > 10)
        return depth; if (obj === null || typeof obj !== 'object')
        return depth; const values = Object.values(obj); if (values.length === 0)
        return depth; return Math.max(...values.map(v => getDepth(v, depth + 1))); }; return getDepth(val) <= 10; }, "JSON nesting depth exceeds maximum of 10"),
    createdAt: z.date(),
    updatedAt: z.date(),
});
// File: ProctoringSessionState.schema.ts
export const ProctoringSessionStateSchema = z.object({
    id: z.number().int(),
    proctoringSessionId: z.number().int(),
    status: z.string(),
    createdAt: z.date(),
    updatedAt: z.date(),
});
// File: ProctoringSessionNote.schema.ts
export const ProctoringSessionNoteSchema = z.object({
    id: z.number().int(),
    proctoringSessionId: z.number().int(),
    content: z.string(),
    timestamp: z.date(),
    createdAt: z.date(),
    updatedAt: z.date(),
});
// File: ProctoringRoomScanNote.schema.ts
export const ProctoringRoomScanNoteSchema = z.object({
    id: z.number().int(),
    proctoringSessionId: z.number().int(),
    content: z.string(),
    timestamp: z.number().int(),
    createdAt: z.date(),
    updatedAt: z.date(),
});
// File: ExtensionInstallation.schema.ts
export const ExtensionInstallationSchema = z.object({
    id: z.number().int(),
    instanceId: z.number().int(),
    userId: z.number().int().nullish(),
    isUpdate: z.boolean(),
    time: z.date(),
    details: z.unknown().refine((val) => { const getDepth = (obj, depth = 0) => { if (depth > 10)
        return depth; if (obj === null || typeof obj !== 'object')
        return depth; const values = Object.values(obj); if (values.length === 0)
        return depth; return Math.max(...values.map(v => getDepth(v, depth + 1))); }; return getDepth(val) <= 10; }, "JSON nesting depth exceeds maximum of 10").nullish(),
    createdAt: z.date(),
    updatedAt: z.date(),
});
// File: BlackboardAuthorizationRequest.schema.ts
export const BlackboardAuthorizationRequestSchema = z.object({
    id: z.number().int(),
    accountId: z.string(),
    refreshToken: z.string(),
    lmsOrigin: z.string(),
    redirectUri: z.string(),
    codeVerifier: z.string(),
    state: z.string(),
    createdDate: z.date(),
    expiryDate: z.date(),
});
// File: InstituteUpdateLog.schema.ts
export const InstituteUpdateLogSchema = z.object({
    id: z.number().int(),
    accountId: z.string().nullish(),
    userId: z.string().nullish(),
    details: z.unknown().refine((val) => { const getDepth = (obj, depth = 0) => { if (depth > 10)
        return depth; if (obj === null || typeof obj !== 'object')
        return depth; const values = Object.values(obj); if (values.length === 0)
        return depth; return Math.max(...values.map(v => getDepth(v, depth + 1))); }; return getDepth(val) <= 10; }, "JSON nesting depth exceeds maximum of 10").nullish(),
    timestamp: z.date(),
});
// File: Applications.schema.ts
export const ApplicationsSchema = z.object({
    id: z.number().int(),
    name: z.string(),
    processName: z.unknown().refine((val) => { const getDepth = (obj, depth = 0) => { if (depth > 10)
        return depth; if (obj === null || typeof obj !== 'object')
        return depth; const values = Object.values(obj); if (values.length === 0)
        return depth; return Math.max(...values.map(v => getDepth(v, depth + 1))); }; return getDepth(val) <= 10; }, "JSON nesting depth exceeds maximum of 10"),
    iconSvg: z.string(),
    type: z.string(),
    createdAt: z.date(),
    updatedAt: z.date(),
});
// File: Extensions.schema.ts
export const ExtensionsSchema = z.object({
    id: z.number().int(),
    extensionId: z.string(),
    extensionName: z.string(),
    iconSvg: z.string(),
    type: z.string(),
    createdAt: z.date(),
    updatedAt: z.date(),
});
// File: SubAccounts.schema.ts
export const SubAccountsSchema = z.object({
    id: z.number().int(),
    accountName: z.string(),
    instituteId: z.number().int(),
    lmsAccountId: z.string(),
    lmsAccountUuid: z.string().nullish(),
    parentLmsAccountId: z.string().nullish(),
    rootLmsAccountId: z.string().nullish(),
    lmsAccountState: z.string().nullish(),
    verityEnabled: z.boolean(),
    createdAt: z.date(),
    updatedAt: z.date(),
});
// File: ProctoringSessionReport.schema.ts
export const ProctoringSessionReportSchema = z.object({
    proctoringSessionId: z.number().int(),
    studentId: z.number().int(),
    studentName: z.string().nullish(),
    quizId: z.number().int(),
    quizName: z.string().nullish(),
    lmsCourseId: z.number().int(),
    instituteId: z.number().int(),
    type: ProctoringSessionTypeSchema,
    noneFlagCount: z.number().int(),
    minorFlagCount: z.number().int(),
    majorFlagCount: z.number().int(),
    severeFlagCount: z.number().int(),
    secondsProctored: z.number().int(),
    sessionStartTime: z.date(),
    anomalyTypeCount: z.unknown().refine((val) => { const getDepth = (obj, depth = 0) => { if (depth > 10)
        return depth; if (obj === null || typeof obj !== 'object')
        return depth; const values = Object.values(obj); if (values.length === 0)
        return depth; return Math.max(...values.map(v => getDepth(v, depth + 1))); }; return getDepth(val) <= 10; }, "JSON nesting depth exceeds maximum of 10").nullish(),
    createdAt: z.date(),
    updatedAt: z.date(),
});
// File: InstituteReport.schema.ts
export const InstituteReportSchema = z.object({
    id: z.number().int(),
    instituteId: z.number().int(),
    startDate: z.date(),
    endDate: z.date(),
    uniqueStudents: z.unknown().refine((val) => { const getDepth = (obj, depth = 0) => { if (depth > 10)
        return depth; if (obj === null || typeof obj !== 'object')
        return depth; const values = Object.values(obj); if (values.length === 0)
        return depth; return Math.max(...values.map(v => getDepth(v, depth + 1))); }; return getDepth(val) <= 10; }, "JSON nesting depth exceeds maximum of 10"),
    uniqueAssessments: z.unknown().refine((val) => { const getDepth = (obj, depth = 0) => { if (depth > 10)
        return depth; if (obj === null || typeof obj !== 'object')
        return depth; const values = Object.values(obj); if (values.length === 0)
        return depth; return Math.max(...values.map(v => getDepth(v, depth + 1))); }; return getDepth(val) <= 10; }, "JSON nesting depth exceeds maximum of 10"),
    totalSessions: z.number().int(),
    totalLiveSessions: z.number().int(),
    totalLiveCheckInSessions: z.number().int(),
    totalProctoringHours: z.number(),
    totalLiveHours: z.number(),
    averageIntegrityScore: z.number().nullish(),
    anomalyTypeCount: z.unknown().refine((val) => { const getDepth = (obj, depth = 0) => { if (depth > 10)
        return depth; if (obj === null || typeof obj !== 'object')
        return depth; const values = Object.values(obj); if (values.length === 0)
        return depth; return Math.max(...values.map(v => getDepth(v, depth + 1))); }; return getDepth(val) <= 10; }, "JSON nesting depth exceeds maximum of 10").nullish(),
    courseTableData: z.unknown().refine((val) => { const getDepth = (obj, depth = 0) => { if (depth > 10)
        return depth; if (obj === null || typeof obj !== 'object')
        return depth; const values = Object.values(obj); if (values.length === 0)
        return depth; return Math.max(...values.map(v => getDepth(v, depth + 1))); }; return getDepth(val) <= 10; }, "JSON nesting depth exceeds maximum of 10"),
    createdAt: z.date(),
    updatedAt: z.date(),
});
// File: InstituteReportSummary.schema.ts
export const InstituteReportSummarySchema = z.object({
    id: z.number().int(),
    instituteId: z.number().int(),
    startDate: z.date(),
    endDate: z.date(),
    summary: z.unknown().refine((val) => { const getDepth = (obj, depth = 0) => { if (depth > 10)
        return depth; if (obj === null || typeof obj !== 'object')
        return depth; const values = Object.values(obj); if (values.length === 0)
        return depth; return Math.max(...values.map(v => getDepth(v, depth + 1))); }; return getDepth(val) <= 10; }, "JSON nesting depth exceeds maximum of 10"),
    createdAt: z.date(),
    updatedAt: z.date(),
});
// File: InstitutionReportEmail.schema.ts
export const InstitutionReportEmailSchema = z.object({
    id: z.number().int(),
    institutionId: z.number().int(),
    month: z.number().int(),
    year: z.number().int(),
    adminEmails: z.unknown().refine((val) => { const getDepth = (obj, depth = 0) => { if (depth > 10)
        return depth; if (obj === null || typeof obj !== 'object')
        return depth; const values = Object.values(obj); if (values.length === 0)
        return depth; return Math.max(...values.map(v => getDepth(v, depth + 1))); }; return getDepth(val) <= 10; }, "JSON nesting depth exceeds maximum of 10"),
    topMetrics: z.unknown().refine((val) => { const getDepth = (obj, depth = 0) => { if (depth > 10)
        return depth; if (obj === null || typeof obj !== 'object')
        return depth; const values = Object.values(obj); if (values.length === 0)
        return depth; return Math.max(...values.map(v => getDepth(v, depth + 1))); }; return getDepth(val) <= 10; }, "JSON nesting depth exceeds maximum of 10"),
    title: z.string(),
    summary: z.string(),
    isApproved: z.boolean(),
    isSent: z.boolean(),
    createdAt: z.date(),
    updatedAt: z.date(),
});
// File: ExemptedInstitutionReportEmailUsers.schema.ts
export const ExemptedInstitutionReportEmailUsersSchema = z.object({
    id: z.number().int(),
    userId: z.number().int(),
    createdAt: z.date(),
    updatedAt: z.date(),
});
// File: SubAccountReport.schema.ts
export const SubAccountReportSchema = z.object({
    id: z.number().int(),
    subAccountId: z.number().int(),
    instituteId: z.number().int(),
    startDate: z.date(),
    endDate: z.date(),
    uniqueStudents: z.unknown().refine((val) => { const getDepth = (obj, depth = 0) => { if (depth > 10)
        return depth; if (obj === null || typeof obj !== 'object')
        return depth; const values = Object.values(obj); if (values.length === 0)
        return depth; return Math.max(...values.map(v => getDepth(v, depth + 1))); }; return getDepth(val) <= 10; }, "JSON nesting depth exceeds maximum of 10"),
    uniqueAssessments: z.unknown().refine((val) => { const getDepth = (obj, depth = 0) => { if (depth > 10)
        return depth; if (obj === null || typeof obj !== 'object')
        return depth; const values = Object.values(obj); if (values.length === 0)
        return depth; return Math.max(...values.map(v => getDepth(v, depth + 1))); }; return getDepth(val) <= 10; }, "JSON nesting depth exceeds maximum of 10"),
    totalSessions: z.number().int(),
    totalLiveSessions: z.number().int(),
    totalLiveCheckInSessions: z.number().int(),
    totalProctoringHours: z.number(),
    totalLiveHours: z.number(),
    averageIntegrityScore: z.number().nullish(),
    anomalyTypeCount: z.unknown().refine((val) => { const getDepth = (obj, depth = 0) => { if (depth > 10)
        return depth; if (obj === null || typeof obj !== 'object')
        return depth; const values = Object.values(obj); if (values.length === 0)
        return depth; return Math.max(...values.map(v => getDepth(v, depth + 1))); }; return getDepth(val) <= 10; }, "JSON nesting depth exceeds maximum of 10").nullish(),
    courseTableData: z.unknown().refine((val) => { const getDepth = (obj, depth = 0) => { if (depth > 10)
        return depth; if (obj === null || typeof obj !== 'object')
        return depth; const values = Object.values(obj); if (values.length === 0)
        return depth; return Math.max(...values.map(v => getDepth(v, depth + 1))); }; return getDepth(val) <= 10; }, "JSON nesting depth exceeds maximum of 10"),
    createdAt: z.date(),
    updatedAt: z.date(),
});
// File: SubAccountReportSummary.schema.ts
export const SubAccountReportSummarySchema = z.object({
    id: z.number().int(),
    subAccountId: z.number().int(),
    startDate: z.date(),
    endDate: z.date(),
    summary: z.unknown().refine((val) => { const getDepth = (obj, depth = 0) => { if (depth > 10)
        return depth; if (obj === null || typeof obj !== 'object')
        return depth; const values = Object.values(obj); if (values.length === 0)
        return depth; return Math.max(...values.map(v => getDepth(v, depth + 1))); }; return getDepth(val) <= 10; }, "JSON nesting depth exceeds maximum of 10"),
    createdAt: z.date(),
    updatedAt: z.date(),
});
// File: CourseReport.schema.ts
export const CourseReportSchema = z.object({
    id: z.number().int(),
    courseId: z.number().int(),
    startDate: z.date(),
    endDate: z.date(),
    uniqueStudents: z.unknown().refine((val) => { const getDepth = (obj, depth = 0) => { if (depth > 10)
        return depth; if (obj === null || typeof obj !== 'object')
        return depth; const values = Object.values(obj); if (values.length === 0)
        return depth; return Math.max(...values.map(v => getDepth(v, depth + 1))); }; return getDepth(val) <= 10; }, "JSON nesting depth exceeds maximum of 10"),
    uniqueAssessments: z.unknown().refine((val) => { const getDepth = (obj, depth = 0) => { if (depth > 10)
        return depth; if (obj === null || typeof obj !== 'object')
        return depth; const values = Object.values(obj); if (values.length === 0)
        return depth; return Math.max(...values.map(v => getDepth(v, depth + 1))); }; return getDepth(val) <= 10; }, "JSON nesting depth exceeds maximum of 10"),
    totalSessions: z.number().int(),
    totalLiveSessions: z.number().int(),
    totalLiveCheckInSessions: z.number().int(),
    totalProctoringHours: z.number(),
    totalLiveHours: z.number(),
    averageIntegrityScore: z.number().nullish(),
    anomalyTypeCount: z.unknown().refine((val) => { const getDepth = (obj, depth = 0) => { if (depth > 10)
        return depth; if (obj === null || typeof obj !== 'object')
        return depth; const values = Object.values(obj); if (values.length === 0)
        return depth; return Math.max(...values.map(v => getDepth(v, depth + 1))); }; return getDepth(val) <= 10; }, "JSON nesting depth exceeds maximum of 10").nullish(),
    assessmentTableData: z.unknown().refine((val) => { const getDepth = (obj, depth = 0) => { if (depth > 10)
        return depth; if (obj === null || typeof obj !== 'object')
        return depth; const values = Object.values(obj); if (values.length === 0)
        return depth; return Math.max(...values.map(v => getDepth(v, depth + 1))); }; return getDepth(val) <= 10; }, "JSON nesting depth exceeds maximum of 10"),
    createdAt: z.date(),
    updatedAt: z.date(),
});
// File: CourseReportSummary.schema.ts
export const CourseReportSummarySchema = z.object({
    id: z.number().int(),
    courseId: z.number().int(),
    startDate: z.date(),
    endDate: z.date(),
    summary: z.unknown().refine((val) => { const getDepth = (obj, depth = 0) => { if (depth > 10)
        return depth; if (obj === null || typeof obj !== 'object')
        return depth; const values = Object.values(obj); if (values.length === 0)
        return depth; return Math.max(...values.map(v => getDepth(v, depth + 1))); }; return getDepth(val) <= 10; }, "JSON nesting depth exceeds maximum of 10"),
    createdAt: z.date(),
    updatedAt: z.date(),
});
// File: MoodleAccessToken.schema.ts
export const MoodleAccessTokenSchema = z.object({
    id: z.number().int(),
    instituteId: z.number().int(),
    accessToken: z.string(),
});
// File: SocketSession.schema.ts
export const SocketSessionSchema = z.object({
    id: z.number().int(),
    proctoringSessionUuid: z.string(),
    createdAt: z.date(),
});
// File: SocketEvent.schema.ts
export const SocketEventSchema = z.object({
    id: z.number().int(),
    socketSessionId: z.number().int(),
    name: z.string(),
    createdAt: z.date(),
    ackedAt: z.date().nullish(),
});
// File: LmsTokenAuthorizationRequest.schema.ts
export const LmsTokenAuthorizationRequestSchema = z.object({
    id: z.number().int(),
    state: z.string(),
    userId: z.number().int(),
    courseId: z.number().int(),
    callbackUrl: z.string(),
    createdAt: z.date(),
});
// File: ScratchNote.schema.ts
export const ScratchNoteSchema = z.object({
    id: z.string(),
    proctoringSessionUuid: z.string(),
    mimeType: ScratchNoteMimeTypeSchema,
    createdAt: z.date(),
    uploadedAt: z.date().nullish(),
});
// File: ApiRouteConfig.schema.ts
export const ApiRouteConfigSchema = z.object({
    id: z.number().int(),
    version: ApiVersionSchema,
    route: z.string(),
    instituteId: z.number().int(),
    active: z.boolean(),
    createdAt: z.date(),
    updatedAt: z.date(),
});
// File: Recording.schema.ts
export const RecordingSchema = z.object({
    id: z.number().int(),
    proctoringSessionId: z.number().int(),
    recordingId: z.string(),
    sourceIndex: z.number().int(),
    type: RecordingTypeSchema,
    chunked: z.boolean().default(true),
    createdAt: z.date(),
    updatedAt: z.date(),
});
// File: RecordingConcatenationRequest.schema.ts
export const RecordingConcatenationRequestSchema = z.object({
    proctoringSessionId: z.number().int(),
    type: z.string(),
    number: z.number().int(),
    requestId: z.string(),
    status: ConcatenationRequestStatusSchema.default("POSTPROCESS_STARTED"),
    createdAt: z.date(),
    updatedAt: z.date(),
});
// File: Rule.schema.ts
export const RuleSchema = z.object({
    id: z.number().int(),
    instituteId: z.number().int(),
    scope: RuleScopeSchema,
    scopeValue: z.string().nullish(),
    type: RuleTypeSchema,
    details: z.unknown().refine((val) => { const getDepth = (obj, depth = 0) => { if (depth > 10)
        return depth; if (obj === null || typeof obj !== 'object')
        return depth; const values = Object.values(obj); if (values.length === 0)
        return depth; return Math.max(...values.map(v => getDepth(v, depth + 1))); }; return getDepth(val) <= 10; }, "JSON nesting depth exceeds maximum of 10").nullish(),
    order: z.number().int(),
    enabled: z.boolean().default(true),
    createdAt: z.date(),
    updatedAt: z.date(),
});
// File: TemporaryEnabledCourse.schema.ts
export const TemporaryEnabledCourseSchema = z.object({
    id: z.number().int(),
    courseId: z.string(),
    instituteId: z.number().int(),
});
// File: ProctoringSessionDataDump.schema.ts
export const ProctoringSessionDataDumpSchema = z.object({
    id: z.string(),
    proctoringSessionId: z.number().int(),
    source: z.string(),
    mimeType: z.string(),
    createdAt: z.date(),
    uploadedAt: z.date().nullish(),
});
// File: InstitutionPaymentOptions.schema.ts
export const InstitutionPaymentOptionsSchema = z.object({
    id: z.number().int(),
    currency: z.string(),
    instituteId: z.number().int(),
    automatedType: PaymentTypeSchema.default("assessment"),
    liveProctoringType: PaymentTypeSchema.default("assessment"),
    liveCheckInType: PaymentTypeSchema.default("assessment"),
    livePostReviewType: PaymentTypeSchema.default("assessment"),
    livePostReviewPrice: z.number(),
    liveCheckInPrice: z.number(),
    liveProctoringPrice: z.number(),
    automatedProctoringPrice: z.number(),
    enabled: z.boolean(),
    createdAt: z.date(),
    updatedAt: z.date(),
});
// File: StripePaymentSession.schema.ts
export const StripePaymentSessionSchema = z.object({
    id: z.number().int(),
    assessmentId: z.number().int(),
    userId: z.number().int(),
    proctoringSessionId: z.number().int().nullish(),
    stripeSessionId: z.string(),
    paid: z.boolean(),
    claimed: z.boolean(),
    createdAt: z.date(),
    updatedAt: z.date(),
});
// File: RestrictedDevicePeer.schema.ts
export const RestrictedDevicePeerSchema = z.object({
    id: z.string(),
    proctoringSessionId: z.number().int(),
    role: RestrictedDeviceRoleSchema,
    platform: RestrictedDevicePlatformSchema,
    options: z.unknown().refine((val) => { const getDepth = (obj, depth = 0) => { if (depth > 10)
        return depth; if (obj === null || typeof obj !== 'object')
        return depth; const values = Object.values(obj); if (values.length === 0)
        return depth; return Math.max(...values.map(v => getDepth(v, depth + 1))); }; return getDepth(val) <= 10; }, "JSON nesting depth exceeds maximum of 10").nullish(),
});
// File: RestrictedDeviceState.schema.ts
export const RestrictedDeviceStateSchema = z.object({
    id: z.number().int(),
    peerId: z.string(),
    connected: z.boolean(),
    data: z.unknown().refine((val) => { const getDepth = (obj, depth = 0) => { if (depth > 10)
        return depth; if (obj === null || typeof obj !== 'object')
        return depth; const values = Object.values(obj); if (values.length === 0)
        return depth; return Math.max(...values.map(v => getDepth(v, depth + 1))); }; return getDepth(val) <= 10; }, "JSON nesting depth exceeds maximum of 10").nullish(),
    createdAt: z.date(),
    updatedAt: z.date(),
});
// File: RestrictedDeviceSingleUseGrant.schema.ts
export const RestrictedDeviceSingleUseGrantSchema = z.object({
    id: z.number().int(),
    peerId: z.string(),
    secret: z.string(),
    accountId: z.string().nullish(),
    createdAt: z.date(),
});
// File: Feedback.schema.ts
export const FeedbackSchema = z.object({
    id: z.number().int(),
    userId: z.number().int(),
    satisfaction: SatisfactionLevelSchema,
    category: FeedbackCategorySchema,
    summary: z.string(),
    details: z.string(),
    status: FeedbackStatusSchema.default("notStarted"),
    isDeleted: z.boolean(),
    createdAt: z.date(),
    updatedAt: z.date(),
});
// File: EventBanner.schema.ts
export const EventBannerSchema = z.object({
    id: z.number().int(),
    createdBy: z.number().int(),
    title: z.string(),
    link: z.string(),
    buttonText: z.string(),
    institutions: z.unknown().refine((val) => { const getDepth = (obj, depth = 0) => { if (depth > 10)
        return depth; if (obj === null || typeof obj !== 'object')
        return depth; const values = Object.values(obj); if (values.length === 0)
        return depth; return Math.max(...values.map(v => getDepth(v, depth + 1))); }; return getDepth(val) <= 10; }, "JSON nesting depth exceeds maximum of 10").nullish(),
    roles: z.unknown().refine((val) => { const getDepth = (obj, depth = 0) => { if (depth > 10)
        return depth; if (obj === null || typeof obj !== 'object')
        return depth; const values = Object.values(obj); if (values.length === 0)
        return depth; return Math.max(...values.map(v => getDepth(v, depth + 1))); }; return getDepth(val) <= 10; }, "JSON nesting depth exceeds maximum of 10").nullish(),
    startDate: z.date(),
    endDate: z.date(),
    isDeleted: z.boolean(),
    createdAt: z.date(),
    updatedAt: z.date(),
});
// File: InferenceToken.schema.ts
export const InferenceTokenSchema = z.object({
    id: z.string(),
    proctoringSessionId: z.number().int(),
    data: z.string(),
    createdAt: z.date(),
    updatedAt: z.date(),
});
// File: InstituteState.schema.ts
export const InstituteStateSchema = z.object({
    instituteId: z.number().int(),
    lastVisualizerLaunchTime: z.date().nullish(),
    lastLti1p3LaunchTime: z.date().nullish(),
    ltiQuickLinkTemplate: z.string().nullish(),
    ltiQuickLinkTemplateAt: z.date().nullish(),
    createdAt: z.date(),
    updatedAt: z.date(),
});
// File: InstituteSetupGuide.schema.ts
export const InstituteSetupGuideSchema = z.object({
    instituteId: z.number().int(),
    setupProfileId: z.number().int().nullish(),
    setupQuizId: z.number().int().nullish(),
    takeStepUserId: z.number().int().nullish(),
    lti1p3SetupComplete: z.boolean(),
    visualizerSetupComplete: z.boolean(),
    apiSetupComplete: z.boolean(),
    profileSetupComplete: z.boolean(),
    extensionSetupComplete: z.boolean(),
    createSetupComplete: z.boolean(),
    takeSetupComplete: z.boolean(),
    resultSetupComplete: z.boolean(),
    createdAt: z.date(),
    updatedAt: z.date(),
});
// File: ProctoringSessionSummary.schema.ts
export const ProctoringSessionSummarySchema = z.object({
    id: z.number().int(),
    proctoringSessionId: z.number().int(),
    source: ProctoringSessionSummarySourceSchema.default("ai"),
    summary: z.unknown().refine((val) => { const getDepth = (obj, depth = 0) => { if (depth > 10)
        return depth; if (obj === null || typeof obj !== 'object')
        return depth; const values = Object.values(obj); if (values.length === 0)
        return depth; return Math.max(...values.map(v => getDepth(v, depth + 1))); }; return getDepth(val) <= 10; }, "JSON nesting depth exceeds maximum of 10"),
    authorId: z.string().nullish(),
    createdAt: z.date(),
    updatedAt: z.date(),
});
// File: SetupSupportChatMessage.schema.ts
export const SetupSupportChatMessageSchema = z.object({
    id: z.number().int(),
    proctoringSessionId: z.number().int(),
    fromUser: z.boolean(),
    timestamp: z.date(),
    message: z.string(),
});
// File: CandidateInterviewOptions.schema.ts
export const CandidateInterviewOptionsSchema = z.object({
    id: z.number().int(),
    title: z.string(),
    candidateName: z.string(),
    candidateEmail: z.string(),
    positionName: z.string(),
    videoPlatform: VideoPlatformSchema,
    meetingLink: z.string(),
    notes: z.string().nullish(),
    proctoringAssessmentConfigurationId: z.number().int(),
});
// File: CronExpireRecording.schema.ts
export const CronExpireRecordingSchema = z.object({
    id: z.number().int(),
    instituteId: z.number().int(),
    lastProcessedId: z.number().int(),
    startedAt: z.date(),
    updatedAt: z.date(),
    stoppedAt: z.date().nullish(),
});
// File: QuizQuestion.schema.ts
export const QuizQuestionSchema = z.object({
    id: z.number().int(),
    quizId: z.number().int(),
    questionText: z.string(),
    questionOrder: z.number().int(),
    questionType: QuestionTypeSchema,
    correctionPoints: z.number(),
    options: z.unknown().refine((val) => { const getDepth = (obj, depth = 0) => { if (depth > 10)
        return depth; if (obj === null || typeof obj !== 'object')
        return depth; const values = Object.values(obj); if (values.length === 0)
        return depth; return Math.max(...values.map(v => getDepth(v, depth + 1))); }; return getDepth(val) <= 10; }, "JSON nesting depth exceeds maximum of 10").nullish(),
    configuration: z.unknown().refine((val) => { const getDepth = (obj, depth = 0) => { if (depth > 10)
        return depth; if (obj === null || typeof obj !== 'object')
        return depth; const values = Object.values(obj); if (values.length === 0)
        return depth; return Math.max(...values.map(v => getDepth(v, depth + 1))); }; return getDepth(val) <= 10; }, "JSON nesting depth exceeds maximum of 10").nullish(),
    isDeleted: z.boolean(),
    aiGradingEnabled: z.boolean(),
    aiGradingCriteria: z.string().nullish(),
    createdAt: z.date(),
    updatedAt: z.date(),
});
// File: QuizResponse.schema.ts
export const QuizResponseSchema = z.object({
    id: z.number().int(),
    sessionId: z.number().int(),
    questionSnapshot: z.unknown().refine((val) => { const getDepth = (obj, depth = 0) => { if (depth > 10)
        return depth; if (obj === null || typeof obj !== 'object')
        return depth; const values = Object.values(obj); if (values.length === 0)
        return depth; return Math.max(...values.map(v => getDepth(v, depth + 1))); }; return getDepth(val) <= 10; }, "JSON nesting depth exceeds maximum of 10"),
    questionNo: z.number().int(),
    answer: z.unknown().refine((val) => { const getDepth = (obj, depth = 0) => { if (depth > 10)
        return depth; if (obj === null || typeof obj !== 'object')
        return depth; const values = Object.values(obj); if (values.length === 0)
        return depth; return Math.max(...values.map(v => getDepth(v, depth + 1))); }; return getDepth(val) <= 10; }, "JSON nesting depth exceeds maximum of 10").nullish(),
    isAnswered: z.boolean(),
    createdAt: z.date(),
    updatedAt: z.date(),
});
// File: QuizResponseGrade.schema.ts
export const QuizResponseGradeSchema = z.object({
    id: z.number().int(),
    responseId: z.number().int(),
    score: z.number(),
    notes: z.string().nullish(),
    isDraft: z.boolean().default(true),
    isGraded: z.boolean().default(true),
    gradedByAi: z.boolean(),
    aiJustification: z.string().nullish(),
    createdAt: z.date(),
    updatedAt: z.date(),
});
// File: Fingerprints.schema.ts
export const FingerprintsSchema = z.object({
    id: z.number().int(),
    fingerprint: z.string(),
    questionId: z.number().int(),
    responseId: z.number().int(),
    wordOffset: z.number().int(),
    createdAt: z.date(),
    updatedAt: z.date(),
});
//# sourceMappingURL=index.js.map